/* eslint-disable */
/* THIS IS AN AUTO-GENERATED FILE */
/*
    ____            .    _  .
   /# /_\_          |\_|/__/|
  |  |/o\o\        / / \/ \  \
  |  \\_/_/       /__|O||O|__ \
 / |_   |        |/_ \_/\_/ _\ |
|  ||\_ ~|       | | (____) | ||
|  ||| \/        \/\___/\__/  //
|  |||_          (_/         ||
 \//  |           |          ||
  ||  |           |          ||\
  ||_  \           \        //_/
  \_|  o|           \______//
  /\___/          __ || __||
 /  ||||__       (____(____)
    (___)_)
run 'yarn codegen' to create a new one
*/
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  JSON: { [key: string]: any };
};

export interface Address {
  city: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Float'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<StateCodes>;
  updatedAt: Scalars['DateTime'];
  zip: Scalars['String'];
}

export interface AddressInput {
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<StateCodes>;
  zip?: Maybe<Scalars['String']>;
}

export interface AdminAlert {
  careType?: Maybe<CareType>;
  message: Scalars['String'];
  resolveBy?: Maybe<Scalars['String']>;
  type: AdminAlertType;
}

export const AdminAlertType = {
  ConfirmPatientReactivation: 'ConfirmPatientReactivation',
  MissingPharmacy: 'MissingPharmacy',
  ReactivatePatient: 'ReactivatePatient',
  SponsoredCareExpiring: 'SponsoredCareExpiring',
  UnfinishedNote: 'UnfinishedNote',
} as const;

export type AdminAlertType = typeof AdminAlertType[keyof typeof AdminAlertType];
export interface Allocation {
  appointmentTypes?: Maybe<Array<Scalars['String']>>;
  childOrganizations?: Maybe<Array<Organization>>;
  endTime: Scalars['DateTime'];
  id: Scalars['Float'];
  isFeeForServiceTime?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  provider: Provider;
  providerId: Scalars['Float'];
  purpose: TimeAllocationPurpose;
  repeatsUntil?: Maybe<Scalars['DateTime']>;
  startTime: Scalars['DateTime'];
  timezone: Scalars['String'];
  weekly: Scalars['Boolean'];
}

/** The different kinds of alternative care */
export const AlternativeCare = {
  CampusCrisisLine: 'campusCrisisLine',
  CollegeCounselor: 'collegeCounselor',
  EmergencyRoom: 'emergencyRoom',
  MantraTherapy: 'mantraTherapy',
  NoSupport: 'noSupport',
  OffCampusTherapy: 'offCampusTherapy',
  Other: 'other',
  OtherOr998: 'otherOr998',
  Unsure: 'unsure',
} as const;

export type AlternativeCare = typeof AlternativeCare[keyof typeof AlternativeCare];
export interface Answer {
  answer?: Maybe<Scalars['String']>;
  answerKey?: Maybe<Scalars['JSON']>;
  key: Scalars['String'];
  legend?: Maybe<Array<Scalars['String']>>;
  multiText?: Maybe<Array<Scalars['String']>>;
  score?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  textForProviders?: Maybe<Scalars['String']>;
  value: Scalars['JSON'];
}

export interface AnswerSubmission {
  answerKey?: Maybe<Scalars['JSON']>;
  key: Scalars['String'];
  multiText?: Maybe<Array<Scalars['String']>>;
  score?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
}

export interface AppointmentCharge {
  amountInCents: Scalars['Float'];
  capturedAt: Scalars['DateTime'];
  chargeType: AppointmentChargeType;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
}

export const AppointmentChargeType = {
  Copay: 'Copay',
  LateCancellationFee: 'LateCancellationFee',
  NoShowFee: 'NoShowFee',
  PatientResponsibility: 'PatientResponsibility',
  SelfPay: 'SelfPay',
} as const;

export type AppointmentChargeType =
  typeof AppointmentChargeType[keyof typeof AppointmentChargeType];
export interface AppointmentFeedbackInput {
  audioQualityDown?: Maybe<CallQuality>;
  audioQualityUp?: Maybe<CallQuality>;
  comments?: Maybe<Scalars['String']>;
  issues?: Maybe<Array<Scalars['String']>>;
  overallRating?: Maybe<Scalars['Float']>;
  userDevice?: Maybe<Scalars['JSON']>;
  videoQualityDown?: Maybe<CallQuality>;
  videoQualityUp?: Maybe<CallQuality>;
  videoRating?: Maybe<Scalars['Float']>;
}

export interface AppointmentTemplate {
  appointmentType: Scalars['String'];
  careType: CareType;
  description: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['Float'];
  organization: Organization;
}

export interface AppointmentTemplateUpdate {
  appointmentType: Scalars['String'];
  careType: Scalars['String'];
  duration: Scalars['Int'];
}

export const AppointmentType = {
  Adhoc: 'adhoc',
  Checkin: 'checkin',
  Intake: 'intake',
} as const;

export type AppointmentType = typeof AppointmentType[keyof typeof AppointmentType];
export const AppView = {
  Mcp: 'mcp',
  Oz: 'oz',
  Referral: 'referral',
} as const;

export type AppView = typeof AppView[keyof typeof AppView];
export interface Assessment {
  id: Scalars['Float'];
  key: AssessmentKey;
  questionnaires: Array<Questionnaire>;
}

export const AssessmentKey = {
  AdjustedIntake: 'AdjustedIntake',
  Bipolar1Assessment: 'Bipolar1Assessment',
  Bipolar1Screener: 'Bipolar1Screener',
  CoachingKickOff: 'CoachingKickOff',
  CoachingWellnessAssessment: 'CoachingWellnessAssessment',
  FindCare: 'FindCare',
  Intake: 'Intake',
  MedicalHistory: 'MedicalHistory',
  Scales: 'Scales',
  SelfRefer1Screener: 'SelfRefer1Screener',
} as const;

export type AssessmentKey = typeof AssessmentKey[keyof typeof AssessmentKey];
export interface AssessmentModel {
  asrsv11: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  gad7: Scalars['Float'];
  id: Scalars['Float'];
  phq9: Scalars['Float'];
  result: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
}

export interface AssessmentRequestModel {
  complete: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Float'];
  key: AssessmentKey;
}

export interface AssessmentResponse {
  createdAt: Scalars['DateTime'];
  followUpRequest?: Maybe<AssessmentRequestModel>;
  id: Scalars['Float'];
  provider?: Maybe<Provider>;
  questionnaires: Array<QuestionnaireResult>;
  specialConditions?: Maybe<SpecialConditions>;
}

export interface AssignableSkill {
  moduleId: Scalars['String'];
  skillId: Scalars['String'];
  title: Scalars['String'];
}

export interface AssignmentPagination {
  page: Scalars['Int'];
  totalPages: Scalars['Int'];
}

export interface AssignSkillToUserResponse {
  isDuplicate: Scalars['Boolean'];
  wasAssigned: Scalars['Boolean'];
}

export interface AsynchronousJob {
  id: Scalars['Float'];
  status: Scalars['String'];
  url?: Maybe<Scalars['String']>;
}

export interface AuthInstructions {
  authMethod: AuthMethod;
  hasPreviousSSOLogin?: Maybe<Scalars['Boolean']>;
  organizationAbbreviation?: Maybe<Scalars['String']>;
  samlEntryPoint?: Maybe<Scalars['String']>;
}

export const AuthMethod = {
  Password: 'Password',
  Saml: 'SAML',
} as const;

export type AuthMethod = typeof AuthMethod[keyof typeof AuthMethod];
export interface Availability {
  blockers: Array<AvailabilityBlockedReason>;
  careType: CareType;
  end: Scalars['String'];
  isFeeForServiceTime?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Float']>;
  provider: Provider;
  providerId: Scalars['Float'];
  start: Scalars['String'];
}

export const AvailabilityBlockedReason = {
  BackToBackIntake: 'BackToBackIntake',
  DedicatedHoursMaxedForWeek: 'DedicatedHoursMaxedForWeek',
  FfsAllocationBlockedForSameDay: 'FFSAllocationBlockedForSameDay',
  IntakesMaxedForDay: 'IntakesMaxedForDay',
  NoDgmHoursLeftForState: 'NoDGMHoursLeftForState',
  NoDgmIntakesLeftForState: 'NoDGMIntakesLeftForState',
} as const;

export type AvailabilityBlockedReason =
  typeof AvailabilityBlockedReason[keyof typeof AvailabilityBlockedReason];
export interface AvailabilityResult {
  data: Array<Availability>;
  interval: Scalars['Float'];
}

/** Calendar events show events related to a patient. */
export interface CalendarEvent {
  adminCrisisProtocolEngagedAt?: Maybe<Scalars['DateTime']>;
  adminCrisisTeamNotifiedAt?: Maybe<Scalars['DateTime']>;
  adminHostCrisisId?: Maybe<Scalars['String']>;
  appointmentType: Scalars['String'];
  cancelledOrRescheduleWithin: Scalars['Boolean'];
  careType: CareType;
  changedOutOfPolicy: Scalars['Boolean'];
  charges: Array<AppointmentCharge>;
  checkedInAt?: Maybe<Scalars['DateTime']>;
  complete: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  finalizedInsuranceClaim?: Maybe<FinalizedInsuranceClaim>;
  id: Scalars['Float'];
  /** Is the appointment blocked by patient tasks */
  isBlocked: Scalars['Boolean'];
  medicalNote?: Maybe<MedicalNote>;
  provider: Provider;
  providerId: Scalars['Float'];
  providerIncident?: Maybe<ProviderIncident>;
  requiresProviderFeedback: Scalars['Boolean'];
  startTime: Scalars['DateTime'];
  status: Scalars['String'];
  statusChangedAt?: Maybe<Scalars['DateTime']>;
  statusChanges?: Maybe<Array<CalendarStatusChange>>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Float'];
  usesDedicatedGroupModelHours?: Maybe<Scalars['Boolean']>;
  videoSessionId: Scalars['String'];
  videoToken: Scalars['String'];
}

/** Calendar events show events related to a patient. */
export type CalendarEventCancelledOrRescheduleWithinArgs = {
  diffHours: Scalars['Float'];
};

/** Calendar events show events related to a patient. */
export type CalendarEventRequiresProviderFeedbackArgs = {
  includeCurrentAppointment?: Maybe<Scalars['Boolean']>;
};

/** Calendar events show events related to a patient. */
export type CalendarEventStatusChangedAtArgs = {
  toStatuses: Array<Scalars['String']>;
};

export interface CalendarStatusChange {
  actingProvider?: Maybe<Provider>;
  createdAt: Scalars['DateTime'];
  fromStatus: Scalars['String'];
  id: Scalars['Float'];
  toStatus: Scalars['String'];
}

export interface CallQuality {
  bitrate: Scalars['Float'];
  packetLossRatio: Scalars['Float'];
}

export interface CampusTeamMemberInput {
  providerId: Scalars['Int'];
  relationshipType: UniversityRelationship;
}

export interface CampusTeamRelationship {
  provider: Provider;
  relationshipType: UniversityRelationship;
  user: User;
}

export interface CampusTeamRelationshipEvents {
  events: Array<Event>;
  relationship: CampusTeamRelationship;
}

export interface CapacityUsage {
  endTime: Scalars['DateTime'];
  entries: Array<CareTypeUsage>;
  startTime: Scalars['DateTime'];
}

export interface CareEligibility {
  isUserEligible?: Maybe<Scalars['Boolean']>;
  minimumAge: Scalars['Float'];
  permittedCareTypes: Array<CareType>;
}

export interface CareRecommendation {
  recommendation?: Maybe<Scalars['String']>;
}

export interface CareRecommendationResponse {
  careRecommendation?: Maybe<RecommendationOptions>;
  onDemandEnabled: Scalars['Boolean'];
  togetherAllEnabled: Scalars['Boolean'];
}

export interface CareSessionInfo {
  careType: CareType;
  completedAfter?: Maybe<Scalars['DateTime']>;
  completedAppts: Scalars['Float'];
  flowLimit?: Maybe<Scalars['Float']>;
  remainingAppts?: Maybe<Scalars['Float']>;
  unlimitedAppts: Scalars['Boolean'];
  user: User;
}

export const CareStatus = {
  Active: 'Active',
  Cancelled: 'Cancelled',
  Deleted: 'Deleted',
  Discharged: 'Discharged',
  New: 'New',
  OnHold: 'OnHold',
  ScreenedOut: 'ScreenedOut',
} as const;

export type CareStatus = typeof CareStatus[keyof typeof CareStatus];
export interface CareTeamChannel {
  channel: Channel;
  id: Scalars['Float'];
  user: User;
}

export interface CareTeamPreference {
  key: Scalars['String'];
  value: Scalars['JSON'];
}

export interface CareTeamReferral {
  activePatients: Scalars['Float'];
  activeReferrals: Scalars['Float'];
  provider: Provider;
  referralCompletionRate: Scalars['Float'];
  referralsMade: Scalars['Float'];
}

export const CareType = {
  Psychiatry: 'Psychiatry',
  Therapy: 'Therapy',
} as const;

export type CareType = typeof CareType[keyof typeof CareType];
export interface CareTypeUsage {
  careType: CareType;
  minutesAvailable: Scalars['Int'];
  minutesUsed: Scalars['Int'];
}

export interface Channel {
  createdAt: Scalars['DateTime'];
  id: Scalars['Float'];
  lastMessage?: Maybe<MessageV2>;
  messages: Array<MessageV2>;
  /** all providers who have sent messages in the channel */
  uniqProviders: Array<Provider>;
  unreadMessageCount: Scalars['Float'];
  unreadMessages: Array<MessageV2>;
}

export const ClaimAction = {
  Note: 'Note',
  StatusChange: 'StatusChange',
} as const;

export type ClaimAction = typeof ClaimAction[keyof typeof ClaimAction];
export interface CoachChatMessage {
  author: CoachChatMessageAuthor;
  content: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
}

export const CoachChatMessageAuthor = {
  Coach: 'coach',
  Patient: 'patient',
} as const;

export type CoachChatMessageAuthor =
  typeof CoachChatMessageAuthor[keyof typeof CoachChatMessageAuthor];
export interface CoachChatUpdate {
  action: Scalars['String'];
  message?: Maybe<CoachChatMessage>;
  messageId: Scalars['String'];
}

export interface CoachDetails {
  avatarUrl: Scalars['String'];
  coachName: Scalars['String'];
}

export interface CoachingAssignmentInfo {
  coach: CoachDetails;
  coachingKickoffAppointmentSchedulingLink: Scalars['String'];
}

export interface CoachingIntakeProgress {
  setGoalsCompleted: Scalars['Boolean'];
  wellnessAssessmentCompleted: Scalars['Boolean'];
}

export const CoachingStatus = {
  Active: 'active',
  Inactive: 'inactive',
  Onboarding: 'onboarding',
} as const;

export type CoachingStatus = typeof CoachingStatus[keyof typeof CoachingStatus];
export interface CoachOverview {
  coachAvatarUrl?: Maybe<Scalars['String']>;
  coachingEndDate?: Maybe<Scalars['String']>;
  coachingStartDate?: Maybe<Scalars['String']>;
  coachName: Scalars['String'];
  hasUnreadMessages: Scalars['Boolean'];
}

export interface ConfigurationOption {
  description: Scalars['String'];
  key: Scalars['String'];
  subText?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  value: Scalars['JSON'];
}

export interface Contact {
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneValidated?: Maybe<Scalars['Boolean']>;
  primary?: Maybe<Scalars['Boolean']>;
  relationship?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  userId: Scalars['Int'];
}

export interface ContactUpsertInput {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  relationship?: Maybe<Scalars['String']>;
  type: Scalars['String'];
}

export interface ContinuityOfCareEligibilityCarePeriodValues {
  currentPeriod: OrganizationCarePeriodModel;
  firstDayOfBreak?: Maybe<Scalars['String']>;
  isCarePeriodEnding?: Maybe<Scalars['Boolean']>;
  isEndingDueToBreak?: Maybe<Scalars['Boolean']>;
  lastDayOfBreak?: Maybe<Scalars['String']>;
  lastDayOfTerm?: Maybe<Scalars['String']>;
  nextPeriod?: Maybe<OrganizationCarePeriodModel>;
}

export interface ContinuityOfCareEligibilityInput {
  additionalNotes?: Maybe<Scalars['String']>;
  careType: CareType;
  enrollment: Scalars['Boolean'];
  interestedInContinuingCare: Scalars['Boolean'];
  paymentType: Scalars['String'];
  providerId?: Maybe<Scalars['Float']>;
  remainingSessions?: Maybe<Scalars['Float']>;
  residentialLocationDuringBreak: Scalars['String'];
  userId: Scalars['Float'];
}

export interface ContinuityOfCareEligibilityModel {
  additionalNotes?: Maybe<Scalars['String']>;
  careType: CareType;
  completedBy: Provider;
  completedById: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  enrollment: Scalars['Boolean'];
  id: Scalars['Int'];
  interestedInContinuingCare: Scalars['Boolean'];
  paymentType: Scalars['String'];
  provider?: Maybe<Provider>;
  providerId: Scalars['Float'];
  remainingSessions?: Maybe<Scalars['Float']>;
  residentialLocationDuringBreak: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Float'];
}

export interface ContinuityOfCareEligibilityResult {
  canContinueCare: Scalars['Boolean'];
  enrollment: Scalars['Boolean'];
  interestedInContinuingCare: Scalars['Boolean'];
  isEligible: Scalars['Boolean'];
  needsReferral: Scalars['Boolean'];
  paymentType: PaymentType;
  providerInState: Scalars['Boolean'];
}

export interface ContinuityOfCareEligibilityValidation {
  careType: CareType;
  paymentType: PaymentType;
}

export interface ContinuityOfCareModel {
  careType: CareType;
  completedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  nextSteps: NextSteps;
  pendingUser?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  requestedCareOutOfState?: Maybe<Scalars['Boolean']>;
  requiresReferral?: Maybe<Scalars['Boolean']>;
  secondaryState?: Maybe<StateCodes>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: User;
}

export interface CreateAllocationInput {
  appointmentTypes?: Maybe<Array<Scalars['String']>>;
  childOrganizationIds?: Maybe<Array<Scalars['Float']>>;
  endTime: Scalars['DateTime'];
  isFeeForServiceTime?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Float']>;
  purpose: TimeAllocationPurpose;
  repeatsUntil?: Maybe<Scalars['DateTime']>;
  startTime: Scalars['DateTime'];
}

export interface CreateCareTransition {
  careType: CareType;
  nextSteps: NextSteps;
  reason?: Maybe<Scalars['String']>;
  requiresReferral?: Maybe<Scalars['Boolean']>;
  secondaryState?: Maybe<StateCodes>;
  userId: Scalars['Int'];
}

export interface CreateFileUpload {
  globallyShared: Scalars['Boolean'];
  key: Scalars['String'];
  name: Scalars['String'];
  type: UploadType;
  userId?: Maybe<Scalars['Float']>;
}

export interface CreateIntake {
  endTime: Scalars['DateTime'];
  isFeeForServiceTime?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Float']>;
  providerId: Scalars['Float'];
  startTime: Scalars['DateTime'];
}

export interface CreateOrganization {
  abbreviation: Scalars['String'];
  careTypes: Array<CareType>;
  departmentAddress: Scalars['String'];
  departmentHours: Scalars['String'];
  departmentName: Scalars['String'];
  emailDomains: Array<Scalars['String']>;
  entitlements: Array<OrganizationEntitlementInput>;
  name: Scalars['String'];
  type: OrganizationType;
}

export interface CreateOrganizationAnnouncementInput {
  details?: Maybe<Scalars['String']>;
  organizationId: Scalars['Float'];
  title: Scalars['String'];
}

export interface CreateProviderStateAllocationsModelInput {
  endDate: Scalars['String'];
  maxHours: Scalars['Float'];
  maxIntakeHours: Scalars['Float'];
  providerStateId: Scalars['Int'];
  startDate: Scalars['String'];
}

export interface CreateStaff {
  classification: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  npi?: Maybe<Scalars['String']>;
  organizationId: Scalars['Float'];
  phone: Scalars['String'];
  postNominalTitles: Scalars['String'];
  role: CreateStaffRole;
}

export const CreateStaffRole = {
  UniversityAdmin: 'universityAdmin',
  UniversityReferrer: 'universityReferrer',
  UniversityStaff: 'universityStaff',
  UniversitySupportingClinician: 'universitySupportingClinician',
} as const;

export type CreateStaffRole = typeof CreateStaffRole[keyof typeof CreateStaffRole];
export interface CreateTestUser {
  careTypes: Array<CareType>;
  completeCheckout?: Maybe<Scalars['Boolean']>;
  completeProfile?: Maybe<Scalars['Boolean']>;
  defaultPaymentSource?: Maybe<PaymentSource>;
  includeAppointmentFeedback?: Maybe<Scalars['Boolean']>;
  medicalHistory?: Maybe<Scalars['Boolean']>;
  mockMessages?: Maybe<Scalars['Boolean']>;
  numAppointments?: Maybe<Scalars['Float']>;
  numAssessments?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  psychiatristId?: Maybe<Scalars['Float']>;
  referralSource: ReferralSource;
  therapistId?: Maybe<Scalars['Float']>;
  withPharmacy?: Maybe<Scalars['Boolean']>;
}

export interface CreateTicketInput {
  assigneeId?: Maybe<Scalars['Float']>;
  category: TicketCategory;
  description?: Maybe<Scalars['String']>;
  priority?: Maybe<TicketPriority>;
  resolveIn24Hrs?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  userId?: Maybe<Scalars['Float']>;
}

export interface CreateUser {
  birthDate: Scalars['String'];
  campusTeam?: Maybe<Array<CampusTeamMemberInput>>;
  careTypes: Array<CareType>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  geoState: StateCodes;
  lastName: Scalars['String'];
  organizationId: Scalars['Float'];
  phone: Scalars['String'];
  preferredName?: Maybe<Scalars['String']>;
  samlUniqueId?: Maybe<Scalars['String']>;
  suggestedProviders?: Maybe<Array<Scalars['Float']>>;
}

export interface CreateUserDemographicsInput {
  academicProgram: Scalars['String'];
  ethnicity: Scalars['String'];
  genderIdentity: Scalars['String'];
  isInternationalStudent: Scalars['Boolean'];
  sexualOrientation: Scalars['String'];
  yearInProgram: Scalars['String'];
}

export interface CrisisTeamHours {
  dayOfWeek: DayOfWeek;
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
}

export interface CrisisTeamHoursInput {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
}

export interface CrisisTeamRelationship {
  crisisPhone: Scalars['String'];
  organization: Organization;
  provider: Provider;
}

export interface DataSharingConsent {
  endDate: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  revokedAt?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
}

export interface DataSharingRequest {
  canProviderSendReminder: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  lastReminderSentDate?: Maybe<Scalars['DateTime']>;
  pending: Scalars['Boolean'];
  provider: Provider;
}

export const DayOfWeek = {
  Friday: 'Friday',
  Monday: 'Monday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  Thursday: 'Thursday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];
export interface DdhFileReport {
  callId: Scalars['String'];
  callStart: Scalars['DateTime'];
  ddhFileSuccessId: Scalars['Float'];
  id: Scalars['Float'];
}

export interface DdhFileSuccess {
  ddhFileEntityId: Scalars['Float'];
  id: Scalars['Float'];
  organizationId: Scalars['Float'];
  reportDate: Scalars['String'];
  reports?: Maybe<Array<DdhFileReport>>;
  zipLink: Scalars['String'];
}

export interface DebugUserCareFlow {
  careStatus: CareStatus;
  careType: CareType;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  paymentSource: PaymentSource;
  taskStatus: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  validEnd?: Maybe<Scalars['DateTime']>;
  validStart: Scalars['DateTime'];
}

export interface Dependency {
  foreignKey?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
}

export interface DependentQuestions {
  /** The question is required if <target> question is blank. */
  requiredIfEmpty?: Maybe<Scalars['Boolean']>;
  requiredIfValues?: Maybe<Array<Scalars['String']>>;
  targetKey: Scalars['String'];
}

export const DiscountType = {
  PercentDiscount: 'PercentDiscount',
  ReplacePrice: 'ReplacePrice',
} as const;

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];
export const EditableUserFields = {
  Address: 'Address',
  CareFlows: 'CareFlows',
  CareTeam: 'CareTeam',
  DateOfBirth: 'DateOfBirth',
  Email: 'Email',
  LegalName: 'LegalName',
  Organization: 'Organization',
  OrgCareTeam: 'OrgCareTeam',
  Phone: 'Phone',
  PreferredName: 'PreferredName',
  Providers: 'Providers',
  SecondaryState: 'SecondaryState',
  UniqueId: 'UniqueId',
} as const;

export type EditableUserFields = typeof EditableUserFields[keyof typeof EditableUserFields];
export interface EditOrganizationAnnouncementInput {
  details?: Maybe<Scalars['String']>;
  title: Scalars['String'];
}

export interface EditOrganizationCarePeriod {
  endDate: Scalars['String'];
  id: Scalars['Int'];
  periodType: PeriodType;
  startDate: Scalars['String'];
}

export interface EditOrganizationHandbookInput {
  campusCrisisTeamInProduct?: Maybe<Scalars['String']>;
  campusSafetyPoliceNumber?: Maybe<Scalars['String']>;
  coPayChargedByPartner?: Maybe<Scalars['String']>;
  defaultTherapyCadence?: Maybe<Scalars['String']>;
  ekgsNearCampus?: Maybe<Scalars['String']>;
  fullADHDEvaluation?: Maybe<Scalars['String']>;
  highLevelProtocolManagingEmergency?: Maybe<Scalars['String']>;
  hospitalization?: Maybe<Scalars['String']>;
  labsNearCampus?: Maybe<Scalars['String']>;
  mainPointOfContactCrisis?: Maybe<Scalars['String']>;
  noShowsCountForSessionLimits?: Maybe<Scalars['String']>;
  protocolForMedicalLeaveDoc?: Maybe<Scalars['String']>;
  requestingAcademicAccomodations?: Maybe<Scalars['String']>;
  sessionLimitsRenew?: Maybe<Scalars['String']>;
  summerBreakEligibility?: Maybe<Scalars['String']>;
  supportingClinician?: Maybe<Scalars['String']>;
  vitalsNearCampus?: Maybe<Scalars['String']>;
  winterBreakEligibility?: Maybe<Scalars['String']>;
}

export interface EditTicketInput {
  assigneeId?: Maybe<Scalars['Float']>;
  blockedReason?: Maybe<Scalars['String']>;
  category?: Maybe<TicketCategory>;
  description?: Maybe<Scalars['String']>;
  priority?: Maybe<TicketPriority>;
  resolveIn24Hrs?: Maybe<Scalars['Boolean']>;
  status?: Maybe<TicketStatus>;
  title?: Maybe<Scalars['String']>;
}

export interface EditUser {
  authToken?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<AddressInput>;
  birthDate?: Maybe<Scalars['String']>;
  campusTeam?: Maybe<Array<CampusTeamMemberInput>>;
  careFlows?: Maybe<Array<UserCareFlowInput>>;
  dtc?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  mantraAdminCareTeam?: Maybe<Array<Scalars['Float']>>;
  organizationId?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  primaryAddress?: Maybe<AddressInput>;
  providerId?: Maybe<Scalars['Int']>;
  samlUniqueId?: Maybe<Scalars['String']>;
  secondaryState?: Maybe<StateCodes>;
  therapistId?: Maybe<Scalars['Int']>;
}

export interface EmbedOrganization {
  name: Scalars['String'];
}

export interface EmbedPatient {
  name: Scalars['String'];
  organization?: Maybe<EmbedOrganization>;
}

export const EngagementTag = {
  Disengaged: 'Disengaged',
  IncompleteTasks: 'IncompleteTasks',
  LimitedSessions: 'LimitedSessions',
  NeedsInsuranceDetails: 'NeedsInsuranceDetails',
  NoShow: 'NoShow',
  Unverified: 'Unverified',
} as const;

export type EngagementTag = typeof EngagementTag[keyof typeof EngagementTag];
export const Entitlement = {
  AllowCharlieHealthIopReferralsViaMcp: 'AllowCharlieHealthIOPReferralsViaMCP',
  AllowMultipleReferralTypes: 'AllowMultipleReferralTypes',
  AllowTogetherAllReferralsViaMcp: 'AllowTogetherAllReferralsViaMCP',
  CampusResources: 'CampusResources',
  CanReactivatePatients: 'CanReactivatePatients',
  Coaching: 'Coaching',
  CollateEmail: 'CollateEmail',
  CrisisTeam: 'CrisisTeam',
  CustomAvailabilityInterval: 'CustomAvailabilityInterval',
  CustomMinAge: 'CustomMinAge',
  DdhSync: 'DDHSync',
  DedicatedGroupModel: 'DedicatedGroupModel',
  DisableCampusResources: 'DisableCampusResources',
  DisablePatientPortal: 'DisablePatientPortal',
  HideReportingDashboard: 'HideReportingDashboard',
  Hub: 'Hub',
  HubTogetherallEnable: 'HubTogetherallEnable',
  ManualSponsoredCareReactivation: 'ManualSponsoredCareReactivation',
  OnDemand: 'OnDemand',
  OrgIdentification: 'OrgIdentification',
  ProviderMatcher: 'ProviderMatcher',
  ReferrerRole: 'ReferrerRole',
  RequireSelfReferEligibilityCheck: 'RequireSelfReferEligibilityCheck',
  RestrictedPatientProfiles: 'RestrictedPatientProfiles',
  ScreenSelfReferStudents: 'ScreenSelfReferStudents',
  SelfReferral: 'SelfReferral',
  SelfReferralCollaborativeModelScreen: 'SelfReferralCollaborativeModelScreen',
  ShowUtilizationTabToMcpAdmin: 'ShowUtilizationTabToMcpAdmin',
  Sso: 'SSO',
  SupportingClinicianRole: 'SupportingClinicianRole',
  UnlimitedNoShows: 'UnlimitedNoShows',
  WholeCampusCare: 'WholeCampusCare',
} as const;

export type Entitlement = typeof Entitlement[keyof typeof Entitlement];
export interface EntitlementDefinition {
  config: Array<EntitlementDefinitionConfig>;
  description: Scalars['String'];
  key: Entitlement;
  name: Scalars['String'];
}

export interface EntitlementDefinitionConfig {
  key: Scalars['String'];
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  size?: Maybe<EntitlementDefinitionConfigSize>;
  smallText?: Maybe<Scalars['String']>;
  type: Scalars['String'];
}

export const EntitlementDefinitionConfigSize = {
  Large: 'large',
  Small: 'small',
} as const;

export type EntitlementDefinitionConfigSize =
  typeof EntitlementDefinitionConfigSize[keyof typeof EntitlementDefinitionConfigSize];
export interface Event {
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['Float'];
  provider?: Maybe<Provider>;
  tag: Scalars['String'];
  user?: Maybe<User>;
}

export interface FaQuestion {
  answer: Scalars['String'];
  examples?: Maybe<Array<Scalars['String']>>;
  question: Scalars['String'];
}

export interface FeedbackAnswer {
  key: Scalars['String'];
  /** JSON stringified value */
  value: Scalars['String'];
}

export const FeedbackType = {
  Followup: 'Followup',
  Initial: 'Initial',
} as const;

export type FeedbackType = typeof FeedbackType[keyof typeof FeedbackType];
export interface FinalizedInsuranceClaim {
  insurancePaidInCents: Scalars['Float'];
  patientResponsibilityInCents: Scalars['Float'];
}

export interface FindCareStartOutput {
  onDemandEnabled: Scalars['Boolean'];
  questionnaire: Questionnaire;
}

export interface FinishSkillReflectionResponse {
  deleted?: Maybe<Scalars['Boolean']>;
  saved?: Maybe<Scalars['Boolean']>;
}

export interface FirstFactorResult {
  /** Token to be included with the second factor mutation when using 2FA */
  firstFactorToken: Scalars['String'];
  /** Last 4 digits of phone number used in two factor auth */
  phoneLastFour: Scalars['String'];
}

export interface FormSection {
  /** Copy after the main question */
  afterCopy?: Maybe<Array<SectionCopy>>;
  background?: Maybe<SectionColor>;
  /** Copy before the main question */
  beforeCopy?: Maybe<Array<SectionCopy>>;
  border?: Maybe<SectionColor>;
  /** Allows for sub-sections */
  children?: Maybe<Array<FormSection>>;
  closeable?: Maybe<Scalars['Boolean']>;
  dependsOn?: Maybe<SectionDependency>;
  format: SectionFormat;
  hooks?: Maybe<Array<SectionHook>>;
  isolatedOption?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  maxSelections?: Maybe<Scalars['Float']>;
  /** Options if selectable */
  options?: Maybe<Array<Scalars['String']>>;
  placeholder?: Maybe<Scalars['String']>;
  /** Prevent submission with outstanding required questions */
  required?: Maybe<Scalars['Boolean']>;
  /** Rules to determine if a field is required or not */
  requiredIf?: Maybe<RequiredIf>;
  sectionTitle?: Maybe<Scalars['String']>;
  selectDependentValues?: Maybe<Array<SelectDependentValue>>;
  startClosed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  /** Hide number when rendering */
  uncounted?: Maybe<Scalars['Boolean']>;
  /** JSON stringified value */
  value?: Maybe<Scalars['String']>;
  warning?: Maybe<TriggeredCopy>;
}

export interface GenericCollegeModalModel {
  description: Scalars['String'];
  id: Scalars['Float'];
  linkText: Scalars['String'];
  organizationId: Scalars['Float'];
  pictureType?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
}

export interface GetUpNextSkillForModuleResult {
  moduleIsComplete: Scalars['Boolean'];
  upNextSkill?: Maybe<Scalars['JSON']>;
  upNextSkillIsComplete: Scalars['Boolean'];
}

export interface GetUpNextSkillResult {
  moduleWillBeComplete: Scalars['Boolean'];
  upNextSkill?: Maybe<Scalars['JSON']>;
  upNextSkillIsComplete: Scalars['Boolean'];
}

export const HookType = {
  ClearOnChange: 'clearOnChange',
} as const;

export type HookType = typeof HookType[keyof typeof HookType];
export interface HubAnswerSubmission {
  answerKeys?: Maybe<Array<Scalars['String']>>;
  manualInput?: Maybe<Scalars['String']>;
  questionKey: Scalars['String'];
}

export interface HubAppointment {
  appointmentTypeId: Scalars['String'];
  appointmentTypeName: Scalars['String'];
  id: Scalars['String'];
  length: Scalars['Float'];
  rescheduleLink?: Maybe<Scalars['String']>;
  start: Scalars['String'];
  zoomJoinUrl: Scalars['String'];
}

export interface HubAssessmentSubmission {
  answers: Array<HubAnswerSubmission>;
  questionnaireKey: Scalars['String'];
}

export interface HubOnDemandData {
  crisisCallPhoneNumber: Scalars['String'];
  crisisSMS?: Maybe<Scalars['String']>;
  crisisWebChat?: Maybe<Scalars['String']>;
}

export interface HubOnDemandOutput {
  onDemandData?: Maybe<HubOnDemandData>;
  onDemandEnabled: Scalars['Boolean'];
}

export interface HubOrganizationResource {
  contact?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  showAsCrisisResource: Scalars['Boolean'];
  website?: Maybe<Scalars['String']>;
}

export interface HubStatusForUser {
  hasHubOnboarded: Scalars['Boolean'];
  isHubEnabled: Scalars['Boolean'];
}

export interface HubUser {
  birthDate?: Maybe<Scalars['Date']>;
  canRedirect: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  hasHubOnboarded: Scalars['Boolean'];
  impersonatingId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  organization?: Maybe<HubUserOrganization>;
  organizationCanAccessCampusResources: Scalars['Boolean'];
  organizationCanAccessCare: Scalars['Boolean'];
  organizationCanAccessTherapy: Scalars['Boolean'];
  organizationCanAccessTogetherAll: Scalars['Boolean'];
  organizationCounselingCenter?: Maybe<HubUserOrgCounselingCenter>;
  organizationHasCoaching: Scalars['Boolean'];
  organizationHasSelfReferrals: Scalars['Boolean'];
  organizationLogo?: Maybe<HubUserOrganizationLogo>;
  phone?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  primaryAddress?: Maybe<Address>;
  pronouns?: Maybe<Scalars['String']>;
  uid: Scalars['String'];
  upcomingAppointment?: Maybe<HubUserHealthieAppointmentData>;
}

export interface HubUserHealthieAppointmentData {
  appointmentTypeId: Scalars['String'];
  appointmentTypeName: Scalars['String'];
  id: Scalars['String'];
  length: Scalars['Float'];
  start: Scalars['String'];
  zoomJoinUrl: Scalars['String'];
}

export interface HubUserOrganization {
  id: Scalars['Int'];
  name: Scalars['String'];
}

export interface HubUserOrganizationLogo {
  contentType: Scalars['String'];
  url: Scalars['String'];
}

export interface HubUserOrgCounselingCenter {
  departmentAddress: Scalars['String'];
  departmentHours: Scalars['String'];
  departmentName: Scalars['String'];
}

export interface HubUserUpdateInput {
  birthDate?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  primaryAddress?: Maybe<AddressInput>;
  pronouns?: Maybe<Scalars['String']>;
}

export interface Hyperlink {
  displayText: Scalars['String'];
  url: Scalars['String'];
}

export interface InAppNotification {
  createdAt: Scalars['DateTime'];
  data: Scalars['JSON'];
  id: Scalars['Float'];
  isDismissible: Scalars['Boolean'];
  isRequired?: Maybe<Scalars['Boolean']>;
  key: UserNotificationKey;
}

export interface InsuranceClaim {
  balanceCents: Scalars['Float'];
  events: Array<InsuranceClaimEvent>;
  externalStatus: Scalars['String'];
  geoState: Scalars['String'];
  id: Scalars['Float'];
  internalStatus: InternalStatus;
  payer: Payer;
  provider: Provider;
  sentDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
  visitDate: Scalars['DateTime'];
}

export interface InsuranceClaimEvent {
  action: ClaimAction;
  actor?: Maybe<Provider>;
  codes: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  details: Scalars['String'];
  id: Scalars['Float'];
  status: InternalStatus;
  updatedAt: Scalars['DateTime'];
}

export interface InsuranceDetails {
  deductibleRemainingCents?: Maybe<Scalars['Float']>;
  eligibilityVerified: Scalars['Boolean'];
  groupNumber?: Maybe<Scalars['String']>;
  inNetwork: Scalars['Boolean'];
  lastChecked?: Maybe<Scalars['DateTime']>;
  memberId?: Maybe<Scalars['String']>;
  noMentalHealthBenefits?: Maybe<Scalars['Boolean']>;
  patientRelationshipToSubscriber: PatientRelationshipToSubscriber;
  payer?: Maybe<Payer>;
  state: Scalars['String'];
  subscriberDateOfBirth?: Maybe<Scalars['String']>;
  subscriberFirstName?: Maybe<Scalars['String']>;
  subscriberGender?: Maybe<Scalars['String']>;
  subscriberLastName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
}

export interface InsuranceDetailsInput {
  birthDate?: Maybe<Scalars['String']>;
  enteredByProviderId?: Maybe<Scalars['Float']>;
  firstName?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  patientRelationshipToSubscriber: PatientRelationshipToSubscriber;
  payerId?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  subscriberDateOfBirth?: Maybe<Scalars['String']>;
  subscriberFirstName?: Maybe<Scalars['String']>;
  subscriberGender?: Maybe<Scalars['String']>;
  subscriberLastName?: Maybe<Scalars['String']>;
}

export interface InsuranceEligibility {
  inNetwork: Scalars['Boolean'];
  noMentalHealthBenefits?: Maybe<Scalars['Boolean']>;
  valid: Scalars['Boolean'];
}

export interface IntakeAvailabilityResult {
  data: Array<Availability>;
  duration: Scalars['Float'];
  interval: Scalars['Float'];
}

export const InternalStatus = {
  Accepted: 'Accepted',
  Cancelled: 'Cancelled',
  Closed: 'Closed',
  Created: 'Created',
  Denied: 'Denied',
  FollowUp: 'FollowUp',
  Rejected: 'Rejected',
  Sent: 'Sent',
} as const;

export type InternalStatus = typeof InternalStatus[keyof typeof InternalStatus];
export interface Invoice {
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  paid: Scalars['Boolean'];
}

export interface JumpBackInSkillData {
  module?: Maybe<Scalars['JSON']>;
  skill?: Maybe<Scalars['JSON']>;
}

export interface ListCopy {
  bullets: Array<Scalars['String']>;
  showInView?: Maybe<Scalars['Boolean']>;
  style?: Maybe<TextStyle>;
}

export const LoginHubError = {
  InvalidToken: 'invalid_token',
  InvalidTokenId: 'invalid_token_id',
} as const;

export type LoginHubError = typeof LoginHubError[keyof typeof LoginHubError];
export interface LoginHubResult {
  error?: Maybe<LoginHubError>;
  hasHubOnboarded?: Maybe<Scalars['Boolean']>;
  success?: Maybe<LoginHubSuccess>;
}

export interface LoginHubSuccess {
  impersonated: Scalars['Boolean'];
  jwt?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
}

/** The main concerns of a user */
export const MainConcerns = {
  Academics: 'ACADEMICS',
  AnxietyStress: 'ANXIETY_STRESS',
  CareerPlanning: 'CAREER_PLANNING',
  ConcernForSomeoneElse: 'CONCERN_FOR_SOMEONE_ELSE',
  Depression: 'DEPRESSION',
  Family: 'FAMILY',
  FeelingDown: 'FEELING_DOWN',
  Finances: 'FINANCES',
  FriendsRoommates: 'FRIENDS_ROOMMATES',
  Grief: 'GRIEF',
  HealthConcerns: 'HEALTH_CONCERNS',
  Lgbtqia: 'LGBTQIA',
  LifeChanges: 'LIFE_CHANGES',
  Loneliness: 'LONELINESS',
  Other: 'OTHER',
  Relationship: 'RELATIONSHIP',
  SelfInjury: 'SELF_INJURY',
  SubstanceAbuse: 'SUBSTANCE_ABUSE',
  SuicidalThoughts: 'SUICIDAL_THOUGHTS',
  Work: 'WORK',
} as const;

export type MainConcerns = typeof MainConcerns[keyof typeof MainConcerns];
export interface ManualInput {
  label?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
}

export interface MaybeBlockedCalendarEvents {
  blockedReason?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  data?: Maybe<CalendarEvent>;
}

export interface MaybeBlockedProviders {
  blockedReason?: Maybe<ProviderServiceBlockedReason>;
  data?: Maybe<Array<Provider>>;
}

export interface MedicalHistory {
  createdAt: Scalars['DateTime'];
  id: Scalars['Float'];
  questionnaires: Array<MedicalHistoryQuestionnaire>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Float'];
  uuid: Scalars['String'];
}

export interface MedicalHistoryQuestion {
  caption?: Maybe<Scalars['String']>;
  dependency?: Maybe<Dependency>;
  disclaimer?: Maybe<Scalars['String']>;
  examples?: Maybe<Array<Scalars['String']>>;
  isOptional?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  legend?: Maybe<Array<Scalars['String']>>;
  manualInput?: Maybe<ManualInput>;
  options?: Maybe<Array<Option>>;
  overrideDescription?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  preText?: Maybe<Scalars['String']>;
  subText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
  visible?: Maybe<Scalars['Boolean']>;
}

export interface MedicalHistoryQuestionnaire {
  description?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  preScreen?: Maybe<QuestionnairePreScreen>;
  questions: Array<MedicalHistoryQuestion>;
  title: Scalars['String'];
}

export interface MedicalNote {
  appointment?: Maybe<CalendarEvent>;
  claimSubmitted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Float'];
  key: Scalars['String'];
  provider: Provider;
  submittedAt?: Maybe<Scalars['DateTime']>;
  template: MedicalNoteTemplate;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  valueForKey?: Maybe<Scalars['String']>;
}

export type MedicalNoteValueForKeyArgs = {
  key: Scalars['String'];
};

export interface MedicalNoteSectionInput {
  key: Scalars['String'];
  /** JSON stringified value */
  value?: Maybe<Scalars['String']>;
}

export interface MedicalNoteTemplate {
  careTypes?: Maybe<Array<CareType>>;
  key: Scalars['String'];
  patientDetails?: Maybe<Array<PatientDetail>>;
  questions: Array<FormSection>;
  title: Scalars['String'];
  titleTag?: Maybe<TextTag>;
  uuid: Scalars['String'];
}

export interface MedicationInfo {
  brandNames: Array<Scalars['String']>;
  faq: Array<FaQuestion>;
  fdaApprovedTreatmentOf: Array<Scalars['String']>;
  medicationGuidelines: Array<Hyperlink>;
  name: Scalars['String'];
  safetyInformation: SafetyInfo;
  whatToExpect: Scalars['String'];
}

export const MedicationStatus = {
  Active: 'Active',
  CancelDenied: 'CancelDenied',
  Cancelled: 'Cancelled',
  CancelPending: 'CancelPending',
  CancelRequested: 'CancelRequested',
  Changed: 'Changed',
  Completed: 'Completed',
  Deleted: 'Deleted',
  Discontinued: 'Discontinued',
  Inactive: 'Inactive',
  Unknown: 'Unknown',
} as const;

export type MedicationStatus = typeof MedicationStatus[keyof typeof MedicationStatus];
export interface MessageV2 {
  attachments: Array<Upload>;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  /** Do not use this with queries that return arrays of messages */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
}

export interface Mutation {
  activateCrisisMode: Scalars['String'];
  activateSafetyPlan: SafetyPlan;
  addProviderToCrisisTeams: Scalars['Boolean'];
  addSelfReferralEmails: Scalars['Boolean'];
  addUserCareEligibilitySubmission: ContinuityOfCareEligibilityResult;
  adminAcceptTermsOfService: Scalars['Boolean'];
  adminAuthenticate: PasswordAuthResult;
  adminBeginUpload: SignedS3Upload;
  adminCancelAppointment: CalendarEvent;
  adminCompleteOrganizationPhotoUpload: Scalars['Boolean'];
  adminCompleteProviderPhotoUpload: Provider;
  adminCompleteUpload: Upload;
  adminContinuityOfCareExport: AsynchronousJob;
  adminCreateCareTransition: ContinuityOfCareModel;
  adminCreateNoteExport: AsynchronousJob;
  adminCreateStaff: Provider;
  adminCreateTestUser: User;
  adminCreateUser: User;
  adminDeleteUpload: Scalars['Boolean'];
  adminDisableTwoFactor: Scalars['Boolean'];
  adminEditSafetyPlan: SafetyPlan;
  adminEditUser: User;
  adminEndCall: Scalars['Boolean'];
  adminEnterSecondFactor: TwoFactorAuthResult;
  adminMarkNoShow: Scalars['Boolean'];
  adminMarkTaskDone: Scalars['Boolean'];
  adminMarkUpcoming: Scalars['Boolean'];
  adminModifyAppointment: CalendarEvent;
  adminPasswordlessLogin: Scalars['String'];
  adminRescheduleAppointment: CalendarEvent;
  adminResetProviderPassword: Scalars['Boolean'];
  adminScheduleAppointment: CalendarEvent;
  /** Send a two factor code for the authenticated provider (use for verification) */
  adminSendTwoFactorCode: Scalars['Boolean'];
  adminSetPharmacyOnPatient: Scalars['Boolean'];
  adminSetTwoFactorConfig: Scalars['Boolean'];
  adminSubmitAssessment: AssessmentResponse;
  adminTransitionForCarePeriod: Scalars['Boolean'];
  adminTriggerProviderPasswordlessFlow: Scalars['Boolean'];
  adminUndoTaskDone: Scalars['Boolean'];
  adminUpdateAllocationsForDate: Scalars['Boolean'];
  adminUpdateProvider: Provider;
  adminUpdateScreenUserResult: Scalars['Boolean'];
  adminUpdateStateAllocationsForDate: Scalars['Boolean'];
  adminUpdateUpload: Scalars['Boolean'];
  adminVerifyTwoFactorPhone: Scalars['String'];
  answerSkillReflectionQuestion: Scalars['Boolean'];
  applyCoupon?: Maybe<ServiceCoupon>;
  assignSkillToUser: AssignSkillToUserResponse;
  assignStudentToCoach: Scalars['Boolean'];
  autoApplyCoupons: Array<ServiceCoupon>;
  beginEmailVerification: Scalars['Boolean'];
  beginSponsoredCareReenrollment: Scalars['Boolean'];
  beginUpload: SignedS3Upload;
  cancelAppointment: Scalars['Boolean'];
  cancelHealthieAppointment: Scalars['Boolean'];
  cancelSponsoredCareReenrollment: Scalars['Boolean'];
  changeProviderPassword: Scalars['Boolean'];
  changeStatusOfClaim: InsuranceClaimEvent;
  checkIsBlurry: Scalars['Boolean'];
  clearProviderLockout: Scalars['Boolean'];
  completeAppointmentCheckin: CalendarEvent;
  completePendingTransition: Scalars['Boolean'];
  completeUpload: Upload;
  consumeCoachingRecommendation: Scalars['Boolean'];
  consumeTherapyRecommendation: Scalars['Boolean'];
  convertPatientCare: User;
  createDataSharingRequest: DataSharingRequest;
  createHubFeedback: Scalars['Boolean'];
  createNoteForClaim: InsuranceClaimEvent;
  createOnDemandEncounter: Scalars['Boolean'];
  createOrganization: Organization;
  createOrganizationAnnouncement: OrganizationAnnouncement;
  createOrUpdateOrganizationResource: OrganizationResource;
  createOrUpdatePayer: Payer;
  createPartnerReferral: Scalars['Boolean'];
  createProvider: Provider;
  createTestVideoSession: TestVideoSession;
  createTicket: Ticket;
  createUserFirstStep: User;
  createZendeskTicket: Scalars['Boolean'];
  debugImpersonateAsUser: Scalars['String'];
  debugLoginAsUser: Scalars['String'];
  /** Internal debug tooling */
  debugModifyDataSharingConsent: DataSharingConsent;
  /** Internal debug tooling */
  debugModifyDataSharingRequest: DataSharingRequest;
  deleteEmergencyContact: Contact;
  deleteInsuranceCredential: Scalars['Boolean'];
  deleteMedicalNote: Scalars['Boolean'];
  deleteOrganizationResource: Scalars['Boolean'];
  deleteOutreachAttempt: Scalars['Boolean'];
  deleteUserCareEligibilitySubmission: Scalars['Boolean'];
  deleteUserContact: Scalars['Boolean'];
  deleteZendeskUpload: Scalars['Boolean'];
  disableDevice: Scalars['Boolean'];
  dismissNotification: Scalars['Boolean'];
  dropInsurance: Scalars['Boolean'];
  editOrganizationAnnouncement: Scalars['Boolean'];
  editOrganizationHandbook: Scalars['Boolean'];
  editSafetyPlan: SafetyPlan;
  /** null if current provider gives up permission to view ticket */
  editTicket?: Maybe<Ticket>;
  emailUnsubscribe: Scalars['Boolean'];
  findCareFinish: Scalars['Boolean'];
  finishProviderPasswordReset: Scalars['Boolean'];
  finishResetPassword: Scalars['Boolean'];
  finishSkillReflection: FinishSkillReflectionResponse;
  /** @deprecated use pushAssessment instead */
  forceNextScalesToNow: Scalars['Boolean'];
  forgotProviderPassword: Scalars['Boolean'];
  /** returns unsubmitted note of key for user or creates a new one */
  getOrCreateNote: MedicalNote;
  impersonate: Scalars['String'];
  initializeStudent: User;
  loginHub: LoginHubResult;
  loginUserWithPassword: PasswordAuthResult;
  logoutHub: Scalars['Boolean'];
  logoutProvider: Scalars['Boolean'];
  logoutUser: Scalars['Boolean'];
  markCareTeamChannelsAsRead: Scalars['Boolean'];
  markHealthieAppointmentForCancellation: Scalars['Boolean'];
  markHubUserOnboarded: Scalars['Boolean'];
  markReferralComplete: Scalars['Boolean'];
  markSkillAssignmentSeenByAssigner: Scalars['Boolean'];
  markSkillComplete: Scalars['Boolean'];
  markSkillStarted: Scalars['Boolean'];
  networkSearchAccommodationRequest: Scalars['Boolean'];
  notifyOrganizationCrisisTeam: Scalars['Boolean'];
  passwordlessLogin: PasswordlessLoginResult;
  patientMarkAsRead: Scalars['Boolean'];
  patientMessageProvider: MessageV2;
  providerMarkPrivateChannelsAsRead: Scalars['Boolean'];
  providerMessagePatient: MessageV2;
  pushAssessment: Scalars['Boolean'];
  reactivateSelfForSponsoredCare: Scalars['Boolean'];
  reactivateUserCareFlow: UserCareFlow;
  reactivateUserForSponsoredCare: Scalars['Boolean'];
  recheckInsuranceEligibility: Scalars['Boolean'];
  refreshProviderLogin: Scalars['String'];
  regenerateProviderPassword: Scalars['String'];
  registerDevice: Scalars['Boolean'];
  removeProviderFromCrisisTeams: Scalars['Boolean'];
  /** Send a two factor code when attempting to authenticate */
  resendTwoFactorCode: Scalars['Boolean'];
  resetBadgeCount: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  resetSessionsForFlow: OrganizationCareFlow;
  resetSessionStartForUser: Scalars['Boolean'];
  resetUserPassword: Scalars['String'];
  resubmitClaim: Scalars['Boolean'];
  /** should be called from the onBlur callback for each question */
  saveNoteSections: Scalars['Boolean'];
  saveUserDemographics: Scalars['Boolean'];
  selectCareFlow: User;
  sendCareTeamMessage: MessageV2;
  sendCoachChatMessage: SendCoachChatMessageResult;
  sendDataSharingRequestReminder: Scalars['Boolean'];
  setDataSharingConsent: Scalars['Boolean'];
  setFlaggedForOutreach: Scalars['Boolean'];
  setHubUserPreferredName: Scalars['Boolean'];
  setInsurance: InsuranceEligibility;
  setPharmacyOnPatient: Scalars['Boolean'];
  setProviderSubscribed: Scalars['Boolean'];
  setSafeOperatingHandbookUrl: Scalars['Boolean'];
  setSuggestedPharmacyId: Scalars['Boolean'];
  setUserInsurance: InsuranceEligibility;
  setUserSubscribed: Scalars['Boolean'];
  setUserVerified: Scalars['Boolean'];
  skillPathwaySubmit: Scalars['Boolean'];
  skillReflectionDelete: Scalars['Boolean'];
  skillReflectionEditAnswer: Scalars['Boolean'];
  skipPharmacySelection: Scalars['Boolean'];
  softDeleteUser: Scalars['Boolean'];
  submitAppointmentFeedback: Scalars['Boolean'];
  submitAppointmentIncident: Scalars['Boolean'];
  submitCoachingAssessment: Scalars['Boolean'];
  submitIntakeAssessment: AssessmentResponse;
  submitMedicalHistory: Scalars['Boolean'];
  submitNote: MedicalNote;
  submitProviderFeedback: Scalars['Boolean'];
  submitRequestedAssessment: Scalars['Boolean'];
  submitSelfRefer1Screener: AssessmentResponse;
  swapPrimaryEmergencyContact: Contact;
  syncHealthieProvider: Scalars['Boolean'];
  toggleOrganizationOnHold: Organization;
  /** Track events from the client */
  track: Scalars['Boolean'];
  trackPushOpen: Scalars['Boolean'];
  triggerPasswordlessAuthFlow: Scalars['Boolean'];
  unassignSkillFromUser: Scalars['Boolean'];
  updateAppointmentTemplates: Scalars['Boolean'];
  updateCareFlowForUser: Scalars['Boolean'];
  updateCertifications: Array<ProviderCertification>;
  updateCoupon: ServiceCoupon;
  updateCrisisTeamHours: Scalars['Boolean'];
  updateEducation: Array<ProviderEducation>;
  updateEligibilityCriteria: Scalars['Boolean'];
  updateEntitlements: Scalars['Boolean'];
  updateHubUser: Scalars['Boolean'];
  updateNotificationOutcome: Scalars['Boolean'];
  updateOrganization: Organization;
  updateOrganizationCareFlows: Array<OrganizationCareFlow>;
  updateOrganizationCarePeriods: Array<OrganizationCarePeriodModel>;
  updateOrganizationDedicatedGroupModelAllocations: Scalars['Boolean'];
  updateOrganizationDefaults: Scalars['Boolean'];
  updateOrganizations: Provider;
  updateOutreachAttempt: Scalars['Boolean'];
  updatePaymentMethod: PaymentMethod;
  updatePreferences: Scalars['Boolean'];
  updateProviderTraits: Scalars['Boolean'];
  updateQualifications: Array<ProviderQualification>;
  updateSamlConfiguration: SamlConfiguration;
  updateScreenUserResult: Scalars['Boolean'];
  updateSponsoredCareReenrollment: Scalars['Boolean'];
  updateUser2: User;
  upsertEmergencyContact: Contact;
  upsertInsuranceCredential: ProviderInsuranceCredential;
  upsertSuggestedProviders: Scalars['Boolean'];
  upsertUserContact: Contact;
  upsertUserSkillFeedback: Scalars['Boolean'];
  userCreateCareTransition: Scalars['Boolean'];
  userScheduleAppointment: CalendarEvent;
}

export type MutationActivateCrisisModeArgs = {
  appointmentId: Scalars['Float'];
};

export type MutationActivateSafetyPlanArgs = {
  userId: Scalars['Float'];
};

export type MutationAddProviderToCrisisTeamsArgs = {
  organizationIds: Array<Scalars['Float']>;
  phone: Scalars['String'];
  providerId: Scalars['Float'];
};

export type MutationAddSelfReferralEmailsArgs = {
  emails: Array<Scalars['String']>;
  organizationId: Scalars['Float'];
};

export type MutationAddUserCareEligibilitySubmissionArgs = {
  submission: ContinuityOfCareEligibilityInput;
};

export type MutationAdminAuthenticateArgs = {
  deviceToken?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MutationAdminBeginUploadArgs = {
  contentType: Scalars['String'];
  userId?: Maybe<Scalars['Float']>;
};

export type MutationAdminCancelAppointmentArgs = {
  id: Scalars['Float'];
  outOfPolicy?: Maybe<Scalars['Boolean']>;
};

export type MutationAdminCompleteOrganizationPhotoUploadArgs = {
  key: Scalars['String'];
  organizationId: Scalars['Float'];
};

export type MutationAdminCompleteProviderPhotoUploadArgs = {
  key?: Maybe<Scalars['String']>;
  providerId: Scalars['Float'];
};

export type MutationAdminCompleteUploadArgs = {
  input: CreateFileUpload;
};

export type MutationAdminContinuityOfCareExportArgs = {
  userId: Scalars['Float'];
};

export type MutationAdminCreateCareTransitionArgs = {
  createTransition: CreateCareTransition;
};

export type MutationAdminCreateNoteExportArgs = {
  noteId: Scalars['Float'];
};

export type MutationAdminCreateStaffArgs = {
  input: CreateStaff;
};

export type MutationAdminCreateTestUserArgs = {
  args: CreateTestUser;
};

export type MutationAdminCreateUserArgs = {
  input: CreateUser;
  intakeAppointment?: Maybe<CreateIntake>;
};

export type MutationAdminDeleteUploadArgs = {
  uploadId: Scalars['Float'];
};

export type MutationAdminEditSafetyPlanArgs = {
  plan: SafetyPlanInput;
  userId: Scalars['Float'];
};

export type MutationAdminEditUserArgs = {
  editUser: EditUser;
};

export type MutationAdminEndCallArgs = {
  appointmentId: Scalars['Float'];
  userId: Scalars['Float'];
};

export type MutationAdminEnterSecondFactorArgs = {
  code: Scalars['String'];
  firstFactorToken: Scalars['String'];
};

export type MutationAdminMarkNoShowArgs = {
  appointmentId: Scalars['Float'];
  userId: Scalars['Float'];
};

export type MutationAdminMarkTaskDoneArgs = {
  taskId: Scalars['Float'];
};

export type MutationAdminMarkUpcomingArgs = {
  id: Scalars['Float'];
};

export type MutationAdminModifyAppointmentArgs = {
  end: Scalars['DateTime'];
  id: Scalars['Float'];
  start: Scalars['DateTime'];
};

export type MutationAdminPasswordlessLoginArgs = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type MutationAdminRescheduleAppointmentArgs = {
  end: Scalars['DateTime'];
  id: Scalars['Float'];
  outOfPolicy?: Maybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
};

export type MutationAdminResetProviderPasswordArgs = {
  id: Scalars['Float'];
};

export type MutationAdminScheduleAppointmentArgs = {
  appointmentType: Scalars['String'];
  end: Scalars['DateTime'];
  isFeeForServiceTime?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Float']>;
  providerId: Scalars['Float'];
  start: Scalars['DateTime'];
  userId: Scalars['Float'];
};

export type MutationAdminSetPharmacyOnPatientArgs = {
  pharmacyId?: Maybe<Scalars['Float']>;
  userId: Scalars['Float'];
};

export type MutationAdminSetTwoFactorConfigArgs = {
  enabled?: Maybe<Scalars['Boolean']>;
  phone: Scalars['String'];
  providerId?: Maybe<Scalars['Float']>;
};

export type MutationAdminSubmitAssessmentArgs = {
  assessment: AssessmentKey;
  questionnaires: Array<QuestionnaireSubmission>;
  userId: Scalars['Float'];
};

export type MutationAdminTransitionForCarePeriodArgs = {
  carePeriodId: Scalars['Float'];
};

export type MutationAdminTriggerProviderPasswordlessFlowArgs = {
  email: Scalars['String'];
};

export type MutationAdminUndoTaskDoneArgs = {
  taskId: Scalars['Float'];
};

export type MutationAdminUpdateAllocationsForDateArgs = {
  allocations: Array<CreateAllocationInput>;
  date: Scalars['String'];
  providerId: Scalars['Float'];
  timezone: Scalars['String'];
  weekly: Scalars['Boolean'];
};

export type MutationAdminUpdateProviderArgs = {
  input: UpdateProvider;
};

export type MutationAdminUpdateScreenUserResultArgs = {
  input: ScreenUserResultInput;
  userId: Scalars['Float'];
};

export type MutationAdminUpdateStateAllocationsForDateArgs = {
  allocationsToCreate: Array<CreateProviderStateAllocationsModelInput>;
  allocationsToUpdate: Array<UpdateProviderStateAllocationsModelInput>;
};

export type MutationAdminUpdateUploadArgs = {
  input: UpdateFileUpload;
};

export type MutationAdminVerifyTwoFactorPhoneArgs = {
  code: Scalars['String'];
  phone: Scalars['String'];
};

export type MutationAnswerSkillReflectionQuestionArgs = {
  answer: Scalars['String'];
  question: Scalars['String'];
  questionKey: Scalars['String'];
  skillId: Scalars['String'];
};

export type MutationApplyCouponArgs = {
  code: Scalars['String'];
};

export type MutationAssignSkillToUserArgs = {
  moduleId: Scalars['String'];
  skillId: Scalars['String'];
  userId: Scalars['Float'];
};

export type MutationAutoApplyCouponsArgs = {
  careType: CareType;
};

export type MutationBeginSponsoredCareReenrollmentArgs = {
  userId: Scalars['Float'];
};

export type MutationBeginUploadArgs = {
  contentType: Scalars['String'];
};

export type MutationCancelAppointmentArgs = {
  appointmentId: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  reasonDetails?: Maybe<Scalars['String']>;
};

export type MutationCancelHealthieAppointmentArgs = {
  appointmentId: Scalars['String'];
};

export type MutationCancelSponsoredCareReenrollmentArgs = {
  userId: Scalars['Float'];
};

export type MutationChangeProviderPasswordArgs = {
  password: Scalars['String'];
};

export type MutationChangeStatusOfClaimArgs = {
  claimId: Scalars['Float'];
  details: Scalars['String'];
  status: InternalStatus;
};

export type MutationCheckIsBlurryArgs = {
  key: Scalars['String'];
  purpose: Scalars['String'];
};

export type MutationClearProviderLockoutArgs = {
  providerId: Scalars['Int'];
};

export type MutationCompleteAppointmentCheckinArgs = {
  appointmentId: Scalars['Int'];
};

export type MutationCompletePendingTransitionArgs = {
  careType: CareType;
};

export type MutationCompleteUploadArgs = {
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  purpose: Scalars['String'];
};

export type MutationConvertPatientCareArgs = {
  careFlows: Array<UserCareFlowInput>;
  userId: Scalars['Float'];
};

export type MutationCreateDataSharingRequestArgs = {
  userId: Scalars['Float'];
};

export type MutationCreateHubFeedbackArgs = {
  feedback: Scalars['String'];
  url: Scalars['String'];
};

export type MutationCreateNoteForClaimArgs = {
  claimId: Scalars['Float'];
  note: Scalars['String'];
};

export type MutationCreateOnDemandEncounterArgs = {
  data: OnDemandEncounterInput;
};

export type MutationCreateOrganizationArgs = {
  input: CreateOrganization;
};

export type MutationCreateOrganizationAnnouncementArgs = {
  input: CreateOrganizationAnnouncementInput;
};

export type MutationCreateOrUpdateOrganizationResourceArgs = {
  organizationId: Scalars['Int'];
  resource: OrganizationResourceInput;
};

export type MutationCreateOrUpdatePayerArgs = {
  params: UpdatePayerParams;
};

export type MutationCreatePartnerReferralArgs = {
  data: PartnerReferralInput;
};

export type MutationCreateProviderArgs = {
  careTypes: Array<CareType>;
  classification: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  funFact?: Maybe<Scalars['String']>;
  geoStates?: Maybe<Array<Scalars['String']>>;
  lastName: Scalars['String'];
  npi: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postNominalTitles?: Maybe<Scalars['String']>;
  withTwoFactor?: Maybe<Scalars['Boolean']>;
};

export type MutationCreateTicketArgs = {
  ticket: CreateTicketInput;
};

export type MutationCreateUserFirstStepArgs = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  password: Scalars['String'];
  preferredName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MutationCreateZendeskTicketArgs = {
  attachmentTokens?: Maybe<Array<Scalars['String']>>;
  body: Scalars['String'];
  subject: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type MutationDebugImpersonateAsUserArgs = {
  reason: Scalars['String'];
  userId: Scalars['Float'];
};

export type MutationDebugLoginAsUserArgs = {
  userId: Scalars['Float'];
};

export type MutationDebugModifyDataSharingConsentArgs = {
  endDate: Scalars['DateTime'];
  id: Scalars['Float'];
  revokedAt?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
};

export type MutationDebugModifyDataSharingRequestArgs = {
  date: Scalars['DateTime'];
  id: Scalars['Float'];
  pending: Scalars['Boolean'];
};

export type MutationDeleteEmergencyContactArgs = {
  id: Scalars['Float'];
};

export type MutationDeleteInsuranceCredentialArgs = {
  id: Scalars['Float'];
};

export type MutationDeleteMedicalNoteArgs = {
  uuid: Scalars['String'];
};

export type MutationDeleteOrganizationResourceArgs = {
  resourceId: Scalars['Int'];
};

export type MutationDeleteOutreachAttemptArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteUserCareEligibilitySubmissionArgs = {
  id: Scalars['Float'];
  userId: Scalars['Float'];
};

export type MutationDeleteUserContactArgs = {
  id: Scalars['Float'];
};

export type MutationDeleteZendeskUploadArgs = {
  token: Scalars['String'];
};

export type MutationDisableDeviceArgs = {
  firebaseToken: Scalars['String'];
};

export type MutationDismissNotificationArgs = {
  id: Scalars['Float'];
};

export type MutationEditOrganizationAnnouncementArgs = {
  id: Scalars['Float'];
  input: EditOrganizationAnnouncementInput;
};

export type MutationEditOrganizationHandbookArgs = {
  input: EditOrganizationHandbookInput;
  organizationId: Scalars['Float'];
};

export type MutationEditSafetyPlanArgs = {
  plan: SafetyPlanInput;
};

export type MutationEditTicketArgs = {
  id: Scalars['Float'];
  ticket: EditTicketInput;
};

export type MutationEmailUnsubscribeArgs = {
  token: Scalars['String'];
};

export type MutationFindCareFinishArgs = {
  submissions: Array<HubAssessmentSubmission>;
};

export type MutationFinishProviderPasswordResetArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type MutationFinishResetPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type MutationFinishSkillReflectionArgs = {
  discardReflection: Scalars['Boolean'];
  skillId: Scalars['String'];
};

export type MutationForceNextScalesToNowArgs = {
  userId: Scalars['Float'];
};

export type MutationForgotProviderPasswordArgs = {
  email: Scalars['String'];
};

export type MutationGetOrCreateNoteArgs = {
  key: Scalars['String'];
  userId: Scalars['Float'];
};

export type MutationImpersonateArgs = {
  providerToImpersonateId: Scalars['Float'];
  reason: Scalars['String'];
};

export type MutationInitializeStudentArgs = {
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  state: StateCodes;
  zip: Scalars['String'];
};

export type MutationLoginHubArgs = {
  token: Scalars['String'];
  tokenId: Scalars['String'];
};

export type MutationLoginUserWithPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MutationMarkCareTeamChannelsAsReadArgs = {
  channels: Array<Scalars['Float']>;
};

export type MutationMarkHealthieAppointmentForCancellationArgs = {
  appointmentId: Scalars['String'];
  appointmentTypeId: Scalars['String'];
};

export type MutationMarkReferralCompleteArgs = {
  userId: Scalars['Float'];
};

export type MutationMarkSkillAssignmentSeenByAssignerArgs = {
  skillAssignmentId: Scalars['Float'];
};

export type MutationMarkSkillCompleteArgs = {
  input: SkillCompletionInputModel;
};

export type MutationMarkSkillStartedArgs = {
  input: SkillCompletionInputModel;
};

export type MutationNetworkSearchAccommodationRequestArgs = {
  accommodationRequestDetails: Scalars['String'];
};

export type MutationNotifyOrganizationCrisisTeamArgs = {
  crisisId: Scalars['String'];
};

export type MutationPasswordlessLoginArgs = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type MutationPatientMarkAsReadArgs = {
  providerId: Scalars['Float'];
};

export type MutationPatientMessageProviderArgs = {
  attachmentIds?: Maybe<Array<Scalars['Float']>>;
  content: Scalars['String'];
  providerId: Scalars['Float'];
};

export type MutationProviderMarkPrivateChannelsAsReadArgs = {
  channels: Array<Scalars['Float']>;
};

export type MutationProviderMessagePatientArgs = {
  attachmentIds?: Maybe<Array<Scalars['Float']>>;
  content: Scalars['String'];
  userId: Scalars['Float'];
};

export type MutationPushAssessmentArgs = {
  assessment: AssessmentKey;
  userId: Scalars['Float'];
};

export type MutationReactivateSelfForSponsoredCareArgs = {
  careType: CareType;
};

export type MutationReactivateUserCareFlowArgs = {
  careType: CareType;
  paymentSource?: Maybe<PaymentSource>;
  userId: Scalars['Float'];
};

export type MutationReactivateUserForSponsoredCareArgs = {
  careType: CareType;
  userId: Scalars['Float'];
};

export type MutationRecheckInsuranceEligibilityArgs = {
  userId: Scalars['Int'];
};

export type MutationRegenerateProviderPasswordArgs = {
  providerId: Scalars['Int'];
};

export type MutationRegisterDeviceArgs = {
  applicationName: Scalars['String'];
  firebaseToken: Scalars['String'];
  platform: Scalars['String'];
};

export type MutationRemoveProviderFromCrisisTeamsArgs = {
  providerId: Scalars['Float'];
};

export type MutationResendTwoFactorCodeArgs = {
  firstFactorToken: Scalars['String'];
};

export type MutationResetBadgeCountArgs = {
  counterName: Scalars['String'];
};

export type MutationResetPasswordArgs = {
  email: Scalars['String'];
};

export type MutationResetSessionsForFlowArgs = {
  appointmentsAfter: Scalars['String'];
  careFlowId: Scalars['Int'];
};

export type MutationResetSessionStartForUserArgs = {
  appointmentsAfter?: Maybe<Scalars['DateTime']>;
  userId: Scalars['Float'];
};

export type MutationResetUserPasswordArgs = {
  userId: Scalars['Float'];
};

export type MutationResubmitClaimArgs = {
  noteId: Scalars['Int'];
};

export type MutationSaveNoteSectionsArgs = {
  sections: Array<MedicalNoteSectionInput>;
  uuid: Scalars['String'];
};

export type MutationSaveUserDemographicsArgs = {
  input: CreateUserDemographicsInput;
};

export type MutationSelectCareFlowArgs = {
  careFlows: Array<UserCareFlowInput>;
};

export type MutationSendCareTeamMessageArgs = {
  content: Scalars['String'];
  userId: Scalars['Float'];
};

export type MutationSendCoachChatMessageArgs = {
  coachingProgramId?: Maybe<Scalars['Float']>;
  content: Scalars['String'];
};

export type MutationSendDataSharingRequestReminderArgs = {
  userId: Scalars['Float'];
};

export type MutationSetDataSharingConsentArgs = {
  consent: Scalars['Boolean'];
  initials?: Maybe<Scalars['String']>;
};

export type MutationSetFlaggedForOutreachArgs = {
  userId: Scalars['Int'];
  value: Scalars['Boolean'];
};

export type MutationSetHubUserPreferredNameArgs = {
  preferredName: Scalars['String'];
};

export type MutationSetInsuranceArgs = {
  insurance: InsuranceDetailsInput;
};

export type MutationSetPharmacyOnPatientArgs = {
  pharmacyId?: Maybe<Scalars['Float']>;
};

export type MutationSetProviderSubscribedArgs = {
  providerId: Scalars['Int'];
  subscribed: Scalars['Boolean'];
};

export type MutationSetSafeOperatingHandbookUrlArgs = {
  organizationId: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type MutationSetSuggestedPharmacyIdArgs = {
  organizationId: Scalars['Int'];
  pharmacyId?: Maybe<Scalars['Int']>;
};

export type MutationSetUserInsuranceArgs = {
  insurance: InsuranceDetailsInput;
  userId: Scalars['Int'];
};

export type MutationSetUserSubscribedArgs = {
  subscribed: Scalars['Boolean'];
  userId: Scalars['Int'];
};

export type MutationSetUserVerifiedArgs = {
  id: Scalars['Float'];
  verify: Scalars['Boolean'];
};

export type MutationSkillPathwaySubmitArgs = {
  answers: Array<SkillPathwayAnswer>;
};

export type MutationSkillReflectionDeleteArgs = {
  reflectionId: Scalars['Float'];
};

export type MutationSkillReflectionEditAnswerArgs = {
  answer: Scalars['String'];
  questionKey: Scalars['String'];
  reflectionId: Scalars['Float'];
};

export type MutationSoftDeleteUserArgs = {
  userId: Scalars['Float'];
};

export type MutationSubmitAppointmentFeedbackArgs = {
  appointmentId: Scalars['Float'];
  feedback: AppointmentFeedbackInput;
};

export type MutationSubmitAppointmentIncidentArgs = {
  appointmentId: Scalars['Float'];
  incident: Scalars['String'];
};

export type MutationSubmitCoachingAssessmentArgs = {
  assessmentType: Scalars['String'];
  submissions: Array<HubAssessmentSubmission>;
};

export type MutationSubmitIntakeAssessmentArgs = {
  questionnaires: Array<QuestionnaireSubmission>;
};

export type MutationSubmitMedicalHistoryArgs = {
  questionnaires: Array<QuestionnaireSubmission>;
};

export type MutationSubmitNoteArgs = {
  sections: Array<MedicalNoteSectionInput>;
  uuid: Scalars['String'];
};

export type MutationSubmitProviderFeedbackArgs = {
  answers?: Maybe<Array<FeedbackAnswer>>;
  careType: CareType;
  feedbackType: FeedbackType;
  optedOut?: Maybe<Scalars['Boolean']>;
  providerId: Scalars['Int'];
};

export type MutationSubmitRequestedAssessmentArgs = {
  questionnaires: Array<QuestionnaireSubmission>;
  requestId: Scalars['Float'];
};

export type MutationSubmitSelfRefer1ScreenerArgs = {
  questionnaires: Array<QuestionnaireSubmission>;
};

export type MutationSwapPrimaryEmergencyContactArgs = {
  id: Scalars['Float'];
  userId: Scalars['Float'];
};

export type MutationSyncHealthieProviderArgs = {
  id: Scalars['Float'];
};

export type MutationToggleOrganizationOnHoldArgs = {
  isOnHold: Scalars['Boolean'];
  organizationId: Scalars['Float'];
};

export type MutationTrackArgs = {
  data?: Maybe<Scalars['JSON']>;
  tag: Scalars['String'];
};

export type MutationTrackPushOpenArgs = {
  createdAt?: Maybe<Scalars['Float']>;
  messageId: Scalars['String'];
  templateId?: Maybe<Scalars['Float']>;
};

export type MutationTriggerPasswordlessAuthFlowArgs = {
  email: Scalars['String'];
};

export type MutationUnassignSkillFromUserArgs = {
  skillAssignmentId: Scalars['Float'];
  userId: Scalars['Float'];
};

export type MutationUpdateAppointmentTemplatesArgs = {
  organizationId: Scalars['Int'];
  templates: Array<AppointmentTemplateUpdate>;
};

export type MutationUpdateCareFlowForUserArgs = {
  careFlow: UserCareFlowInput;
  userId: Scalars['Float'];
};

export type MutationUpdateCertificationsArgs = {
  certifications: Array<ProviderCertificationInput>;
  providerId: Scalars['Float'];
};

export type MutationUpdateCouponArgs = {
  updateCoupon: UpdateCoupon;
};

export type MutationUpdateCrisisTeamHoursArgs = {
  crisisTeamHours: Array<CrisisTeamHoursInput>;
  organizationId: Scalars['Float'];
};

export type MutationUpdateEducationArgs = {
  education: Array<ProviderEducationInput>;
  providerId: Scalars['Float'];
};

export type MutationUpdateEligibilityCriteriaArgs = {
  criteria: Array<OrganizationEligibilityCriteriaInput>;
  organizationId: Scalars['Int'];
};

export type MutationUpdateEntitlementsArgs = {
  entitlements: Array<UpdateOrganizationEntitlementInput>;
  organizationId: Scalars['Float'];
};

export type MutationUpdateHubUserArgs = {
  updates: HubUserUpdateInput;
};

export type MutationUpdateNotificationOutcomeArgs = {
  emailId?: Maybe<Scalars['Int']>;
  outcome: Scalars['String'];
  smsId?: Maybe<Scalars['Int']>;
};

export type MutationUpdateOrganizationArgs = {
  update: UpdateOrganization;
};

export type MutationUpdateOrganizationCareFlowsArgs = {
  careFlows: Array<OrganizationCareFlowInput>;
  organizationId: Scalars['Int'];
};

export type MutationUpdateOrganizationCarePeriodsArgs = {
  editedPeriods: Array<EditOrganizationCarePeriod>;
  newPeriods: Array<NewOrganizationCarePeriod>;
  organizationId: Scalars['Int'];
};

export type MutationUpdateOrganizationDedicatedGroupModelAllocationsArgs = {
  editedOrganizationDedicatedGroupModelAllocations: Array<OrganizationDedicatedGroupModelAllocationInput>;
  organizationId: Scalars['Int'];
};

export type MutationUpdateOrganizationDefaultsArgs = {
  overrides: Array<OrganizationOverrides>;
};

export type MutationUpdateOrganizationsArgs = {
  organizationIds: Array<Scalars['Float']>;
  providerId: Scalars['Float'];
};

export type MutationUpdateOutreachAttemptArgs = {
  attempt: OutreachAttemptInput;
};

export type MutationUpdatePaymentMethodArgs = {
  pmToken: Scalars['String'];
  pmType: Scalars['String'];
};

export type MutationUpdatePreferencesArgs = {
  preferences: Array<CareTeamPreference>;
};

export type MutationUpdateProviderTraitsArgs = {
  providerId: Scalars['Int'];
  traits: Array<ProviderTraitInput>;
};

export type MutationUpdateQualificationsArgs = {
  providerId: Scalars['Float'];
  qualifications: Array<ProviderQualificationInput>;
};

export type MutationUpdateSamlConfigurationArgs = {
  organizationId: Scalars['Int'];
  type: SamlConfigurationType;
  update: UpdateSamlConfiguration;
};

export type MutationUpdateScreenUserResultArgs = {
  input: ScreenUserResultInput;
};

export type MutationUpdateSponsoredCareReenrollmentArgs = {
  status: ReenrollmentStatus;
};

export type MutationUpdateUser2Args = {
  updates: UpdateUserInput;
};

export type MutationUpsertEmergencyContactArgs = {
  id?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  primary?: Maybe<Scalars['Boolean']>;
  relationship: Scalars['String'];
  userId: Scalars['Float'];
};

export type MutationUpsertInsuranceCredentialArgs = {
  credential: UpsertProviderInsuranceCredential;
};

export type MutationUpsertSuggestedProvidersArgs = {
  providerIds: Array<Scalars['Float']>;
  userId: Scalars['Float'];
};

export type MutationUpsertUserContactArgs = {
  input: ContactUpsertInput;
};

export type MutationUpsertUserSkillFeedbackArgs = {
  additionalFeedback: Scalars['String'];
  questions: Array<SkillFeedbackQuestionModelInput>;
  rating: Scalars['Float'];
  skillId: Scalars['String'];
};

export type MutationUserCreateCareTransitionArgs = {
  careType: CareType;
  nextSteps: NextSteps;
};

export type MutationUserScheduleAppointmentArgs = {
  checkin: Scalars['Boolean'];
  end: Scalars['DateTime'];
  isFeeForServiceTime?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Float']>;
  providerId: Scalars['Float'];
  reason?: Maybe<Scalars['String']>;
  reasonDetails?: Maybe<Scalars['String']>;
  rescheduleId?: Maybe<Scalars['Float']>;
  start: Scalars['DateTime'];
};

export interface NewOrganizationCarePeriod {
  endDate: Scalars['String'];
  periodType: PeriodType;
  startDate: Scalars['String'];
}

export const NextSteps = {
  ActiveSelfPay: 'activeSelfPay',
  ActiveSponsored: 'activeSponsored',
  Cancel: 'cancel',
  OnHold: 'onHold',
} as const;

export type NextSteps = typeof NextSteps[keyof typeof NextSteps];
export const NextStepsFilter = {
  ActiveSponsored: 'ActiveSponsored',
  Cancelled: 'Cancelled',
  CompletedSelfPay: 'CompletedSelfPay',
  Na: 'NA',
  OnHold: 'OnHold',
  PendingSelfPay: 'PendingSelfPay',
} as const;

export type NextStepsFilter = typeof NextStepsFilter[keyof typeof NextStepsFilter];
export interface NumericKeyValue {
  key: Scalars['ID'];
  value: Scalars['Float'];
}

export interface OnDemandEncounterInput {
  alternativeCare: AlternativeCare;
  currentLocation: Scalars['String'];
  distressLevel: Scalars['Int'];
  mainConcern: MainConcerns;
  otherAlternativeCare?: Maybe<Scalars['String']>;
  otherMainConcern?: Maybe<Scalars['String']>;
  preferredPhoneNumber: Scalars['String'];
  suicidalThoughts: SuicidalThoughts;
}

export interface OnDemandReportsInput {
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['Float']>;
  search?: Maybe<Scalars['String']>;
}

export interface OnDemandSession {
  callStartTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  user: OnDemandSessionUser;
}

export interface OnDemandSessionOrganization {
  id: Scalars['Float'];
  name: Scalars['String'];
}

export interface OnDemandSessionUser {
  customerId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Float'];
  lastName: Scalars['String'];
  organization: OnDemandSessionOrganization;
}

export interface Option {
  key?: Maybe<Scalars['String']>;
  requiresManualInput?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  text: Scalars['String'];
}

export interface Organization {
  abbreviation: Scalars['String'];
  activityStatus: Scalars['String'];
  appointmentTemplate: AppointmentTemplate;
  appointmentTemplates: Array<AppointmentTemplate>;
  careFlows: Array<OrganizationCareFlow>;
  carePeriods: Array<OrganizationCarePeriodModel>;
  children: Array<Organization>;
  childrenCount: Scalars['Int'];
  crisisHours: Array<CrisisTeamHours>;
  crisisHoursActive: Scalars['Boolean'];
  crisisTeamProviders: Array<Provider>;
  currentCarePeriodUtilization?: Maybe<UtilizationVirtualModel>;
  currentCrisisHours?: Maybe<CrisisTeamHours>;
  departmentAddress: Scalars['String'];
  departmentHours: Scalars['String'];
  departmentName: Scalars['String'];
  director?: Maybe<Provider>;
  eligibilityCriteria: Array<OrganizationEligibilityCriteriaModel>;
  emailDomains: Array<Scalars['String']>;
  emergencyResources: Array<OrganizationResource>;
  entitlements: Array<OrganizationEntitlement>;
  highRiskUsers: Array<User>;
  id: Scalars['Int'];
  latestAssessments: Array<AssessmentModel>;
  latestCarePeriod?: Maybe<OrganizationCarePeriodModel>;
  latestNotes: Array<MedicalNote>;
  logo?: Maybe<Upload>;
  missedAppointments: Array<CalendarEvent>;
  name: Scalars['String'];
  nextAvailableTimeSlots: Array<Availability>;
  organizationUtilization?: Maybe<OrganizationUtilizationVirtualModel>;
  parent?: Maybe<Organization>;
  providers: Array<Provider>;
  providersWithParent: Array<Provider>;
  referralCredits?: Maybe<OrganizationReferralCreditOverview>;
  reporting: OrganizationReport;
  resources: Array<OrganizationResource>;
  resourcesUpdatedAt?: Maybe<Scalars['DateTime']>;
  resourcesUpdatedBy?: Maybe<Provider>;
  safeOperatingHandbook: OrganizationHandbook;
  safeOperatingHandbookUrl?: Maybe<Scalars['String']>;
  safetyPlans: Array<SafetyPlan>;
  samlConfiguration?: Maybe<SamlConfiguration>;
  suggestedPharmacy?: Maybe<Pharmacy>;
  suicidalRiskUsers: Array<User>;
  type: Scalars['String'];
  usersWithOnlyIncompleteReferrals: Array<User>;
  usersWithoutReferrals: Array<User>;
  usesDedicatedGroupModel: Scalars['Boolean'];
}

export type OrganizationAppointmentTemplateArgs = {
  careType: CareType;
};

export type OrganizationLatestAssessmentsArgs = {
  limit: Scalars['Float'];
};

export type OrganizationLatestNotesArgs = {
  key?: Maybe<Scalars['String']>;
  limit: Scalars['Float'];
};

export type OrganizationNextAvailableTimeSlotsArgs = {
  appointmentType: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
};

export type OrganizationProvidersArgs = {
  roles?: Maybe<Array<Scalars['String']>>;
};

export type OrganizationProvidersWithParentArgs = {
  roles?: Maybe<Array<Scalars['String']>>;
};

export type OrganizationReportingArgs = {
  carePeriodId?: Maybe<Scalars['Float']>;
  referralSource?: Maybe<ReferralSource>;
};

export type OrganizationSafetyPlansArgs = {
  complete?: Maybe<Scalars['Boolean']>;
};

export type OrganizationSamlConfigurationArgs = {
  type: SamlConfigurationType;
};

export interface OrganizationAnnouncement {
  createdAt: Scalars['DateTime'];
  createdByProviderName: Scalars['String'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  inCurrentCarePeriod: Scalars['Boolean'];
  title: Scalars['String'];
}

export interface OrganizationCareFlow {
  canMcpUsersRefer: Scalars['Boolean'];
  canReferrerUsersRefer: Scalars['Boolean'];
  canSelfRefer: Scalars['Boolean'];
  careType: CareType;
  defaultPaymentSource: PaymentSource;
  hideSessionCount: Scalars['Boolean'];
  id: Scalars['Int'];
  referralRestrictedStates: Array<StateCodes>;
  sponsoredSessions?: Maybe<Scalars['Float']>;
  sponsoredSessionsLimitType: SponsoredSessionsLimitType;
  statesAvailable: Array<StateCodes>;
}

export interface OrganizationCareFlowInput {
  canMcpUsersRefer: Scalars['Boolean'];
  canReferrerUsersRefer: Scalars['Boolean'];
  canSelfRefer: Scalars['Boolean'];
  careType: CareType;
  defaultPaymentSource: PaymentSource;
  hideSessionCount: Scalars['Boolean'];
  referralRestrictedStates: Array<StateCodes>;
  sponsoredSessions?: Maybe<Scalars['Float']>;
  sponsoredSessionsLimitType: SponsoredSessionsLimitType;
}

export interface OrganizationCarePeriodModel {
  endDate: Scalars['String'];
  id: Scalars['Int'];
  organizationId: Scalars['Int'];
  periodType: PeriodType;
  startDate: Scalars['String'];
}

export interface OrganizationDedicatedGroupModelAllocationInput {
  id: Scalars['Int'];
  psychiatryMaxHours?: Maybe<Scalars['Float']>;
  psychiatryMaxIntakeHours?: Maybe<Scalars['Int']>;
  therapyMaxHours?: Maybe<Scalars['Float']>;
  therapyMaxIntakeHours?: Maybe<Scalars['Int']>;
}

export interface OrganizationEligibilityCriteriaInput {
  minimumAge?: Maybe<Scalars['Float']>;
  permittedCareTypes?: Maybe<Array<CareType>>;
  states?: Maybe<Array<Scalars['String']>>;
}

export interface OrganizationEligibilityCriteriaModel {
  id: Scalars['Int'];
  minimumAge?: Maybe<Scalars['Float']>;
  permittedCareTypes?: Maybe<Array<CareType>>;
  states?: Maybe<Array<Scalars['String']>>;
}

export interface OrganizationEntitlement {
  config: Scalars['JSON'];
  id: Scalars['Int'];
  key: Entitlement;
}

export interface OrganizationEntitlementInput {
  config?: Maybe<Scalars['JSON']>;
  key: Entitlement;
}

export interface OrganizationHandbook {
  campusCrisisTeamInProduct: Scalars['String'];
  campusSafetyPoliceNumber: Scalars['String'];
  coPayChargedByPartner: Scalars['String'];
  defaultTherapyCadence: Scalars['String'];
  ekgsNearCampus: Scalars['String'];
  fullADHDEvaluation: Scalars['String'];
  hasManualReactivationEntitlement: Scalars['Boolean'];
  highLevelProtocolManagingEmergency: Scalars['String'];
  hospitalization: Scalars['String'];
  labsNearCampus: Scalars['String'];
  mainPointOfContactCrisis: Scalars['String'];
  noShowsCountForSessionLimits: Scalars['String'];
  organizationId: Scalars['Int'];
  protocolForMedicalLeaveDoc: Scalars['String'];
  requestingAcademicAccomodations: Scalars['String'];
  sessionLimitsRenew: Scalars['String'];
  summerBreakEligibility: Scalars['String'];
  supportingClinician: Scalars['String'];
  vitalsNearCampus: Scalars['String'];
  winterBreakEligibility: Scalars['String'];
}

export interface OrganizationOption {
  id: Scalars['Int'];
  name: Scalars['String'];
}

export interface OrganizationOverrides {
  key: Scalars['String'];
  organizationId: Scalars['Float'];
  value: Scalars['JSON'];
}

export interface OrganizationReferralCreditOverview {
  availableCredits: Scalars['Int'];
  psychiatryCreditWeight: Scalars['Int'];
  referralPeriodEnd?: Maybe<Scalars['DateTime']>;
  therapyCreditWeight: Scalars['Int'];
}

export interface OrganizationReport {
  activeStudentsCount: Scalars['Float'];
  /** Average Time from Referral to First Visit (Seconds) */
  averageReferralToVisitTime?: Maybe<Scalars['Float']>;
  careTeamReferrals: Array<CareTeamReferral>;
  diagnosesBreakdown: Array<UserDiagnosis>;
  patientMonitoring: Array<User>;
  referralCompletionRate?: Maybe<Scalars['Float']>;
  scope: ReportScope;
  visitAttendance: VisitAttendance;
  visitSatisfactionRatings: SatisfactionRating;
}

export interface OrganizationResource {
  contact?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  position: Scalars['Float'];
  resourceSubtype?: Maybe<Scalars['String']>;
  resourceType: ResourceType;
  showAsCrisisResource: Scalars['Boolean'];
  tags: Array<ResourceTag>;
  website?: Maybe<Scalars['String']>;
}

export interface OrganizationResourceInput {
  contact?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  resourceSubtype?: Maybe<Scalars['String']>;
  resourceType: ResourceType;
  showAsCrisisResource?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<ResourceTag>>;
  website?: Maybe<Scalars['String']>;
}

/** All possible organization types */
export const OrganizationType = {
  University: 'University',
} as const;

export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType];
export interface OrganizationUtilizationVirtualModel {
  carePeriodUtilizations: Array<UtilizationVirtualModel>;
}

export interface OrganizationUtilizationWeek {
  endDate: Scalars['String'];
  id: Scalars['Int'];
  organizationId: Scalars['Int'];
  psychiatryHours: UtilizationHours;
  startDate: Scalars['String'];
  therapyHours: UtilizationHours;
}

export interface OutreachAttemptInput {
  attemptNumber?: Maybe<Scalars['Int']>;
  createdByCustom?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  methods: Array<Scalars['String']>;
  outcome: Scalars['String'];
  subject: Scalars['String'];
  userId: Scalars['Int'];
  zendeskTicketId?: Maybe<Scalars['Int']>;
}

export interface OutreachAttemptModel {
  attemptNumber?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Provider>;
  createdByCustom?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  methods: Array<Scalars['String']>;
  outcome: Scalars['String'];
  subject: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  zendeskTicketId?: Maybe<Scalars['Int']>;
}

export interface PaginatedOnDemandSession {
  count?: Maybe<Scalars['Float']>;
  cursor: Scalars['String'];
  hasMore: Scalars['Boolean'];
  items: Array<OnDemandSession>;
  limitCountExceeded?: Maybe<Scalars['Boolean']>;
}

export interface PaginatedUsers {
  count: Scalars['Float'];
  cursor: Scalars['String'];
  hasMore: Scalars['Boolean'];
  items: Array<User>;
  limitCountExceeded?: Maybe<Scalars['Boolean']>;
}

export interface PartnerReferralInput {
  birthDate: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organizationId?: Maybe<Scalars['Float']>;
  partner: PartnerReferralType;
  preferredName?: Maybe<Scalars['String']>;
  providerId: Scalars['Float'];
  referralEmail?: Maybe<Scalars['String']>;
  referralSource: ReferralSource;
  userId?: Maybe<Scalars['Float']>;
}

/** List of valid partner referral types */
export const PartnerReferralType = {
  CharlieHealth: 'CHARLIE_HEALTH',
  Togetherall: 'TOGETHERALL',
} as const;

export type PartnerReferralType = typeof PartnerReferralType[keyof typeof PartnerReferralType];
export interface PasswordAuthResult {
  authToken?: Maybe<Scalars['String']>;
  blockedReason?: Maybe<Scalars['String']>;
  firstFactorResult?: Maybe<FirstFactorResult>;
  passwordCorrect: Scalars['Boolean'];
  twoFactorNeeded: Scalars['Boolean'];
  useOtherApp?: Maybe<UseOtherApp>;
}

export interface PasswordlessLoginResult {
  activationLinkExpired?: Maybe<Scalars['Boolean']>;
  authToken?: Maybe<Scalars['String']>;
  canLogin?: Maybe<Scalars['Boolean']>;
}

export interface PatientChannel {
  channel: Channel;
  id: Scalars['Float'];
  user: User;
}

export interface PatientDetail {
  breakLine?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}

export const PatientRelationshipToSubscriber = {
  CadaverDonor: 'CadaverDonor',
  Child: 'Child',
  ChildWhereInsuredHasNoFinancialResponsibility: 'ChildWhereInsuredHasNoFinancialResponsibility',
  EmancipatedMinor: 'EmancipatedMinor',
  Employee: 'Employee',
  Father: 'Father',
  FosterChild: 'FosterChild',
  Grandchild: 'Grandchild',
  Grandparent: 'Grandparent',
  HandicappedDependent: 'HandicappedDependent',
  InjuredPlaintiff: 'InjuredPlaintiff',
  LifePartner: 'LifePartner',
  Mother: 'Mother',
  NieceOrNephew: 'NieceOrNephew',
  OrganDonor: 'OrganDonor',
  Other: 'Other',
  Self: 'Self',
  SignificantOther: 'SignificantOther',
  SponsoredDependent: 'SponsoredDependent',
  Spouse: 'Spouse',
  StepsonOrStepdaughter: 'StepsonOrStepdaughter',
  Unknown: 'Unknown',
  WardOfTheCourt: 'WardOfTheCourt',
} as const;

export type PatientRelationshipToSubscriber =
  typeof PatientRelationshipToSubscriber[keyof typeof PatientRelationshipToSubscriber];
export interface Payer {
  billToProviderName: Scalars['Boolean'];
  id: Scalars['Float'];
  inNetworkStates: Array<Scalars['String']>;
  name: Scalars['String'];
  standardPayerId: Scalars['String'];
  stateAddressOverrides: Array<PayerStateAddressOverride>;
  tradingPartnerId: Scalars['String'];
  useAddressForAllStates?: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
}

export interface PayerStateAddressOverride {
  id: Scalars['Int'];
  overrideForState: StateCodes;
  stateToUseInstead: StateCodes;
}

export interface PayerStateAddressOverrideInput {
  overrideForState: StateCodes;
  stateToUseInstead: StateCodes;
}

export interface PaymentMethod {
  id: Scalars['String'];
}

export interface PaymentProfile {
  cardType: Scalars['String'];
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  lastFour: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
}

/** Supported Payment Sources */
export const PaymentSource = {
  Insurance: 'Insurance',
  OonInsurance: 'OONInsurance',
  Organization: 'Organization',
  SelfPay: 'SelfPay',
} as const;

export type PaymentSource = typeof PaymentSource[keyof typeof PaymentSource];
export interface PaymentSubscription {
  id: Scalars['String'];
  nextInvoice: Scalars['Float'];
}

export const PaymentType = {
  SelfPay: 'selfPay',
  Sponsored: 'sponsored',
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];
export const PeriodType = {
  NonSponsoredBreak: 'nonSponsoredBreak',
  NonSponsoredTerm: 'nonSponsoredTerm',
  SponsoredBreak: 'sponsoredBreak',
  SponsoredTerm: 'sponsoredTerm',
} as const;

export type PeriodType = typeof PeriodType[keyof typeof PeriodType];
export const Permission = {
  AppointmentCancel: 'appointmentCancel',
  AppointmentCancelAll: 'appointmentCancelAll',
  AppointmentEdit: 'appointmentEdit',
  AppointmentView: 'appointmentView',
  AssessmentPush: 'assessmentPush',
  CampusTeamEdit: 'campusTeamEdit',
  CareDashboards: 'careDashboards',
  CrisisTeamEdit: 'crisisTeamEdit',
  CrisisTeamEngage: 'crisisTeamEngage',
  DedicatedGroupModelAllocationEdit: 'dedicatedGroupModelAllocationEdit',
  Dev: 'dev',
  GeneratePassword: 'generatePassword',
  Impersonate: 'impersonate',
  MantraAdmin: 'mantraAdmin',
  NoteCreate: 'noteCreate',
  NoteCreateReferral: 'noteCreateReferral',
  NoteCreateText: 'noteCreateText',
  NoteExport: 'noteExport',
  OrderLabs: 'orderLabs',
  OrganizationResourcesEdit: 'organizationResourcesEdit',
  OrganizationViewAll: 'organizationViewAll',
  PatientCreate: 'patientCreate',
  PatientEdit: 'patientEdit',
  PatientEditCareFlows: 'patientEditCareFlows',
  PatientEditProviders: 'patientEditProviders',
  PatientList: 'patientList',
  PatientMessage: 'patientMessage',
  PatientVideo: 'patientVideo',
  Phi: 'phi',
  Pii: 'pii',
  Prescribe: 'prescribe',
  ProviderCreate: 'providerCreate',
  ProviderDelete: 'providerDelete',
  ProviderEdit: 'providerEdit',
  ProviderList: 'providerList',
  ProviderMessage: 'providerMessage',
  ProviderMessageViewAll: 'providerMessageViewAll',
  ProviderPasswordReset: 'providerPasswordReset',
  ProviderView: 'providerView',
  ProviderViewEmail: 'providerViewEmail',
  ProviderViewPhone: 'providerViewPhone',
  ReferralsShowOrg: 'referralsShowOrg',
  ReferralsView: 'referralsView',
  Reporting: 'reporting',
  SafetyPlanActivate: 'safetyPlanActivate',
  SafetyPlanEdit: 'safetyPlanEdit',
  SponsoredCareReenrollment: 'sponsoredCareReenrollment',
  TicketCreate: 'ticketCreate',
  TicketView: 'ticketView',
  TicketViewAll: 'ticketViewAll',
  UtilizationView: 'utilizationView',
} as const;

export type Permission = typeof Permission[keyof typeof Permission];
/** Pharmacy data model from Dosespot. */
export interface Pharmacy {
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  default?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  pharmacyId: Scalars['Float'];
  primary?: Maybe<Scalars['Boolean']>;
  primaryFax?: Maybe<Scalars['String']>;
  primaryPhone?: Maybe<Scalars['String']>;
  serviceLevel?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  storeName: Scalars['String'];
  zipCode: Scalars['String'];
}

export const PortalKey = {
  Coaching: 'coaching',
  Hub: 'hub',
  Loca: 'loca',
  NonLocaTherapyGateway: 'nonLocaTherapyGateway',
  Odes: 'odes',
  Psychiatry: 'psychiatry',
  Skills: 'skills',
  Therapy: 'therapy',
  Togetherall: 'togetherall',
} as const;

export type PortalKey = typeof PortalKey[keyof typeof PortalKey];
export interface Prescription {
  addon?: Maybe<Scalars['Boolean']>;
  daysSupply?: Maybe<Scalars['Float']>;
  directions: Scalars['String'];
  dispenseUnitDescription: Scalars['String'];
  displayName: Scalars['String'];
  doseForm: Scalars['String'];
  drugClassification: Scalars['String'];
  effectiveDate: Scalars['String'];
  genericProductName: Scalars['String'];
  info?: Maybe<MedicationInfo>;
  medicationStatus: MedicationStatus;
  ndc?: Maybe<Scalars['String']>;
  prescriptionId: Scalars['Float'];
  quantity: Scalars['String'];
  rawName?: Maybe<Scalars['String']>;
  route: Scalars['String'];
  rxCui: Scalars['String'];
  status: Scalars['Float'];
  strength: Scalars['String'];
  threeMonth?: Maybe<Scalars['Boolean']>;
  writtenDate: Scalars['String'];
}

export interface Prices {
  lateCancellationFee: Scalars['Int'];
  noShowFee: Scalars['Int'];
  psychiatryFollowUp: Scalars['Int'];
  psychiatryIntake: Scalars['Int'];
  therapyFollowUp: Scalars['Int'];
  therapyIntake: Scalars['Int'];
}

export interface Provider {
  /** don't use this in lists, it doesn't use a dataloader yet */
  acceptingNewPatients: Scalars['Boolean'];
  accountSecurityStatus: Scalars['String'];
  activityStatus?: Maybe<Scalars['String']>;
  /** oz, mcp, or referral */
  appView: AppView;
  careTypes: Array<CareType>;
  certifications: Array<ProviderCertification>;
  classification: Scalars['String'];
  degrees: Array<ProviderEducation>;
  dosespotId?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  funFact: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  geoStates: Array<StateCodes>;
  hasDosespot: Scalars['Boolean'];
  hasSso?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  insuranceCredentials: Array<ProviderInsuranceCredential>;
  lastName?: Maybe<Scalars['String']>;
  /** virtualized firstName + lastName */
  name: Scalars['String'];
  npi?: Maybe<Scalars['String']>;
  organizationCrisisTeams: Array<CrisisTeamRelationship>;
  organizations: Array<Organization>;
  patients: Array<User>;
  permissions: Array<Permission>;
  personalTitle?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  portrait?: Maybe<Upload>;
  postNominalTitles?: Maybe<Scalars['String']>;
  privateChannel: Channel;
  pronouns?: Maybe<Scalars['String']>;
  providerStates: Array<ProviderStateRelationShipModel>;
  providerType?: Maybe<Scalars['String']>;
  qualifications: Array<Scalars['String']>;
  qualifications2: Array<ProviderQualification>;
  role: Role;
  traits: Array<ProviderTrait>;
  twoFactorConfig?: Maybe<TwoFactorConfig>;
  unreadProviderMessagesCount: Scalars['Float'];
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  upcomingAvailability: Array<Availability>;
}

export type ProviderAcceptingNewPatientsArgs = {
  organizationId?: Maybe<Scalars['Float']>;
};

export type ProviderInsuranceCredentialsArgs = {
  forState?: Maybe<Scalars['String']>;
};

export type ProviderUpcomingAvailabilityArgs = {
  apptType: Scalars['String'];
  careType?: Maybe<CareType>;
  endTime?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Float']>;
  patientState?: Maybe<StateCodes>;
};

export interface ProviderCertification {
  abbreviation: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
}

export interface ProviderCertificationInput {
  abbreviation: Scalars['String'];
  name: Scalars['String'];
}

export interface ProviderEducation {
  abbreviation: Scalars['String'];
  degree: Scalars['String'];
  id: Scalars['Float'];
  university: Scalars['String'];
}

export interface ProviderEducationInput {
  abbreviation: Scalars['String'];
  degree: Scalars['String'];
  university: Scalars['String'];
}

export interface ProviderFeedback {
  careType: CareType;
  createdAt: Scalars['DateTime'];
  optedOut?: Maybe<Scalars['Boolean']>;
  providerId: Scalars['Int'];
  questions?: Maybe<Array<FormSection>>;
  userId: Scalars['Int'];
}

export interface ProviderIncident {
  appointment: CalendarEvent;
  createdAt: Scalars['DateTime'];
  incident: Scalars['String'];
}

export interface ProviderInsuranceCredential {
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  payer: Payer;
  state: Scalars['String'];
  updatedAt: Scalars['DateTime'];
}

export interface ProviderIsLoggedIn {
  authToken?: Maybe<Scalars['String']>;
  isLoggedIn: Scalars['Boolean'];
}

export interface ProviderNetworkResult {
  /** Number of providers out of payer network */
  outOfNetworkCount: Scalars['Float'];
  providers: Array<Provider>;
  /** The state code if the state is not allowed for the organization and care type. */
  stateNotAllowed?: Maybe<StateCodes>;
}

export interface ProviderQualification {
  abbreviation: Scalars['String'];
  id: Scalars['Float'];
  licences: Array<Scalars['String']>;
  name: Scalars['String'];
  states: Array<Scalars['String']>;
}

export interface ProviderQualificationInput {
  abbreviation: Scalars['String'];
  licences: Array<Scalars['String']>;
  name: Scalars['String'];
  states: Array<Scalars['String']>;
}

export const ProviderServiceBlockedReason = {
  PatientMissingGeoState: 'PatientMissingGeoState',
} as const;

export type ProviderServiceBlockedReason =
  typeof ProviderServiceBlockedReason[keyof typeof ProviderServiceBlockedReason];
export interface ProviderStateAllocationsModel {
  endDate: Scalars['String'];
  id: Scalars['Int'];
  maxHours: Scalars['Float'];
  maxIntakeHours: Scalars['Float'];
  providerState: ProviderStateRelationShipModel;
  providerStateId: Scalars['Int'];
  startDate: Scalars['String'];
}

export interface ProviderStateRelationShipModel {
  id: Scalars['Int'];
  provider: Provider;
  providerId: Scalars['Int'];
  state: StateCodes;
}

export interface ProviderTrait {
  category: TraitCategory;
  values: Array<Scalars['String']>;
}

export interface ProviderTraitInput {
  category: TraitCategory;
  values: Array<Scalars['String']>;
}

export interface Query {
  activeSubscriptions: Array<PaymentSubscription>;
  adminAppointment: CalendarEvent;
  adminAppointmentByCrisisId: MaybeBlockedCalendarEvents;
  adminAppointmentByUser: CalendarEvent;
  adminAppointments: Array<CalendarEvent>;
  adminAppointmentsToday: Array<CalendarEvent>;
  adminAssessment: Assessment;
  adminAssessmentResults: Array<AssessmentResponse>;
  adminAvailability: AvailabilityResult;
  adminDosespotLink?: Maybe<Scalars['String']>;
  adminExistingCalendarEventsInRange: Array<CalendarEvent>;
  /** Find appointments at risk when introducing a new provider availability */
  adminFindApptsAtRisk: Array<CalendarEvent>;
  adminGetAllocations: Array<Allocation>;
  adminGetJob: AsynchronousJob;
  adminGetStateAllocations: Array<ProviderStateAllocationsModel>;
  adminNeedsPatientOutreach: Array<User>;
  adminOrgIntakeAvailability: IntakeAvailabilityResult;
  adminOverviewReport: OrganizationReport;
  adminPatientMonitoring: Array<User>;
  adminProvider: Provider;
  adminScreenUserResult?: Maybe<ScreenUserResult>;
  adminSearchPharmacy: Array<Pharmacy>;
  adminTimeAllocationsToday: Array<Allocation>;
  adminUrgentActionUsers: Array<User>;
  adminUser: User;
  adminUserDemographics?: Maybe<UserDemographics>;
  adminUserNotifications: Array<InAppNotification>;
  adminUserPharmacies: Array<Pharmacy>;
  adminUsersNeedingBooking: Array<User>;
  allEvents: Array<Event>;
  allPayers: Array<Payer>;
  appointment?: Maybe<CalendarEvent>;
  appointments: Array<CalendarEvent>;
  appointmentTemplate: AppointmentTemplate;
  assessmentByKey: Assessment;
  assessmentForRequest: Assessment;
  assessments: Array<AssessmentResponse>;
  authInstructionsForEmail: AuthInstructions;
  availability: AvailabilityResult;
  careEligibility: CareEligibility;
  careNavigators: Array<Provider>;
  careRecommendationGetForUser: CareRecommendationResponse;
  careTeamChannels: Array<CareTeamChannel>;
  checkRegistrationValidity: RegistrationValidity;
  coachingAssignmentInfo: CoachingAssignmentInfo;
  coachingGoalsAssessment: Assessment;
  coachingIntakeProgress: CoachingIntakeProgress;
  coachingKickoffLink: Scalars['String'];
  coachingWellnessAssessment: Assessment;
  coachOverview: CoachOverview;
  configs: Array<ConfigurationOption>;
  coupons: Array<ServiceCoupon>;
  crisisReportsForOrg: Array<DdhFileSuccess>;
  crisisReportsZip: DdhFileSuccess;
  currentHubUser: HubUser;
  currentProvider: Provider;
  currentUser: User;
  /** Internal debug tooling */
  debugCareFlowsForUser: Array<DebugUserCareFlow>;
  /** Internal debug tooling */
  debugDataSharingConsentsForUser: Array<DataSharingConsent>;
  /** Internal debug tooling */
  debugDataSharingRequestsForUser: Array<DataSharingRequest>;
  doesProviderNeedToReactivateUserCareType?: Maybe<ReactivationType>;
  doesUserNeedToReactivateCareType?: Maybe<UserSponsoredReactivation>;
  /** states in which psychiatry is available for dtc */
  dtcPsychiatryStates: Array<Scalars['String']>;
  /** states in which therapy is available for dtc */
  dtcTherapyStates: Array<Scalars['String']>;
  embedPatient?: Maybe<EmbedPatient>;
  embedPatientIdFromHealthieId?: Maybe<Scalars['Float']>;
  entitlementDefinitions: Array<EntitlementDefinition>;
  events: Array<Event>;
  /** environment specific configuration */
  featureFlags: Array<Scalars['String']>;
  fetchProviderFeedbackTemplate: ProviderFeedback;
  findCareStart: FindCareStartOutput;
  findCareUserHasCompleted: Scalars['Boolean'];
  genericCollegeModal: Array<GenericCollegeModalModel>;
  getAllCompletedSkillsForModule: Array<Scalars['String']>;
  getAllNotesAndFormSubmissionsForUser: Array<MedicalNote>;
  getAllNotesForUser: Array<MedicalNote>;
  getAssessmentLink: Scalars['String'];
  getAssignableSkills: Array<AssignableSkill>;
  getBadgeCount: Scalars['Float'];
  getCareRecommendationStatusForUser: RecommendationStatusForUserResponse;
  getClaim: InsuranceClaim;
  getClaims: Array<InsuranceClaim>;
  getCoachChatMessages: Array<CoachChatMessage>;
  getEligibilityCarePeriodValues: ContinuityOfCareEligibilityCarePeriodValues;
  getEligibilityResult: ContinuityOfCareEligibilityResult;
  getHubStatusForUser: HubStatusForUser;
  getJumpBackInSkills: Array<JumpBackInSkillData>;
  getMySkillsAssignments: UserSkillAssignments;
  getNoteByUuid: MedicalNote;
  getPortals: Array<PortalKey>;
  getPossibleAssignees: Array<Provider>;
  getSkillAssignmentCountsForUser: SkillAssignmentCountsResponse;
  getSkillsAssignedToUser: UserSkillAssignments;
  getUpNextSkill: GetUpNextSkillResult;
  getUpNextSkillForModule: GetUpNextSkillForModuleResult;
  hasCompletedAnySkill: Scalars['Boolean'];
  hasSkillBeenStarted: Scalars['Boolean'];
  healthieProviderSynced: Scalars['Boolean'];
  hubAppointmentById: HubAppointment;
  hubGetAssessmentLink: Scalars['String'];
  hubOrganizationResources: Array<HubOrganizationResource>;
  /** @deprecated Deprecated use "appointment" with the appt id */
  intakeCall: CalendarEvent;
  isLoggedInHub: Scalars['Boolean'];
  isSkillComplete: Scalars['Boolean'];
  latestAssessment: AssessmentResponse;
  loadUnfinishedSkillReflection?: Maybe<UnfinishedSkillReflection>;
  mantraAdmins: Array<Provider>;
  medicationsForUser: Array<Prescription>;
  navigateFromHubMobileToWeb: Scalars['String'];
  navigateFromHubToPatientPortal: Scalars['String'];
  navigateFromPatientPortalToHub: Scalars['String'];
  newClaimsCount: Scalars['Float'];
  nextAppointment?: Maybe<CalendarEvent>;
  nextAssessment?: Maybe<Scalars['DateTime']>;
  nextAvailableAppointment?: Maybe<Scalars['DateTime']>;
  notifications: Array<InAppNotification>;
  onDemandOrgSessions?: Maybe<PaginatedOnDemandSession>;
  organization: Organization;
  organizationAnnouncementsByDays: Array<OrganizationAnnouncement>;
  organizationAnnouncementsByOrgId: Array<OrganizationAnnouncement>;
  organizationCampusTeam?: Maybe<Array<CampusTeamRelationship>>;
  organizationHandbook: OrganizationHandbook;
  organizationOnDemand?: Maybe<HubOnDemandOutput>;
  organizations: Array<Organization>;
  paginatedUsers: PaginatedUsers;
  patients: Array<User>;
  patientsMonitoredCount?: Maybe<Scalars['Float']>;
  payers: Array<Payer>;
  permissibleUploadTypes: Array<UploadType>;
  pharmacies: Array<Pharmacy>;
  portalCareRecommendationForUser: CareRecommendation;
  prescriptions: Array<Prescription>;
  prices: Prices;
  privateChannels: Array<PatientChannel>;
  providerById: Provider;
  /** Current provider's campus team events */
  providerCampusTeamEvents?: Maybe<Array<CampusTeamRelationshipEvents>>;
  providerEmails: Array<SentEmail>;
  providerIsLoggedIn: ProviderIsLoggedIn;
  providerNetworkSearch: ProviderNetworkResult;
  providers: Array<Provider>;
  providerSafetyPlans: Array<SafetyPlan>;
  providersById: Array<Provider>;
  providersForUser: MaybeBlockedProviders;
  referrals: Array<User>;
  remainingHoursForRange: Array<RemainingHours>;
  safetyPlans: Array<SafetyPlan>;
  searchPharmacy: Array<Pharmacy>;
  searchPharmacyByAddress: Array<Pharmacy>;
  searchUsers: Array<User>;
  skillPathwayGetForUser?: Maybe<Array<SkillPathwayStep>>;
  skillPathwayNextSkill: SkillPathwayNextSkill;
  skillReflectionGetAllForUser: UserSkillReflections;
  skillReflectionGetUserAnswers?: Maybe<SkillReflectionAnswers>;
  ticket: Ticket;
  tickets: Array<Ticket>;
  traitCategories: Array<ProviderTrait>;
  unreadCareTeamMessages: Scalars['Float'];
  unreadPatientMessages: Scalars['Float'];
  unsubmittedMedicalNotes: Array<MedicalNote>;
  /** number of users who need ID verification */
  unverifiedUserCount: Scalars['Float'];
  upcomingHubAppointment?: Maybe<HubAppointment>;
  userCoachingHealthieStatus: UserCoachingHealthieStatus;
  userCoachingStatus: UserCoachingStatus;
  userDemographics?: Maybe<UserDemographics>;
  userEmails: Array<SentEmail>;
  userHealthieStatus: UserHealthieStatus;
  userIsLoggedIn: UserIsLoggedIn;
  userOutreachAttempts: Array<OutreachAttemptModel>;
  userReferralStatus: User;
  users: Array<User>;
  userSkillFeedback?: Maybe<SkillFeedbackModel>;
  userSmses: Array<SentSmsModel>;
  usersOrganizations: Array<OrganizationOption>;
  weeklyCapacityUsage: Array<CapacityUsage>;
  zendeskLink: Scalars['String'];
}

export type QueryAdminAppointmentArgs = {
  id: Scalars['Float'];
};

export type QueryAdminAppointmentByCrisisIdArgs = {
  crisisId: Scalars['String'];
};

export type QueryAdminAppointmentByUserArgs = {
  appointmentId?: Maybe<Scalars['Float']>;
  userId: Scalars['Float'];
};

export type QueryAdminAppointmentsArgs = {
  allProviders?: Maybe<Scalars['Boolean']>;
  endTime?: Maybe<Scalars['DateTime']>;
  providerId?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['Float']>;
};

export type QueryAdminAssessmentArgs = {
  assessment: AssessmentKey;
  userId: Scalars['Float'];
};

export type QueryAdminAssessmentResultsArgs = {
  userId: Scalars['Float'];
};

export type QueryAdminAvailabilityArgs = {
  appointmentType: Scalars['String'];
  careType: CareType;
  duration: Scalars['Float'];
  end?: Maybe<Scalars['String']>;
  patientState?: Maybe<StateCodes>;
  providerIds: Array<Scalars['Float']>;
  rescheduleId?: Maybe<Scalars['Float']>;
  start: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  userId: Scalars['Float'];
};

export type QueryAdminDosespotLinkArgs = {
  userId: Scalars['Float'];
};

export type QueryAdminExistingCalendarEventsInRangeArgs = {
  apptTypes?: Maybe<Array<Scalars['String']>>;
  careTypes?: Maybe<Array<CareType>>;
  end?: Maybe<Scalars['String']>;
  providerId: Scalars['Float'];
  start: Scalars['String'];
};

export type QueryAdminFindApptsAtRiskArgs = {
  allocations: Array<CreateAllocationInput>;
  date: Scalars['String'];
  providerId: Scalars['Float'];
  timezone: Scalars['String'];
  weekly: Scalars['Boolean'];
};

export type QueryAdminGetAllocationsArgs = {
  providerId: Scalars['Float'];
};

export type QueryAdminGetJobArgs = {
  jobId: Scalars['Float'];
};

export type QueryAdminGetStateAllocationsArgs = {
  providerId: Scalars['Float'];
};

export type QueryAdminOrgIntakeAvailabilityArgs = {
  careType: CareType;
  end?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Float']>;
  patientState?: Maybe<StateCodes>;
  providerIds: Array<Scalars['Float']>;
  start: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

export type QueryAdminOverviewReportArgs = {
  scope: ReportScope;
};

export type QueryAdminProviderArgs = {
  providerId: Scalars['Float'];
};

export type QueryAdminScreenUserResultArgs = {
  userId: Scalars['Float'];
};

export type QueryAdminSearchPharmacyArgs = {
  query: Scalars['String'];
};

export type QueryAdminUserArgs = {
  id: Scalars['Float'];
};

export type QueryAdminUserDemographicsArgs = {
  id: Scalars['Float'];
};

export type QueryAdminUserNotificationsArgs = {
  userId: Scalars['Float'];
};

export type QueryAdminUserPharmaciesArgs = {
  userId: Scalars['Float'];
};

export type QueryAdminUsersNeedingBookingArgs = {
  careType: CareType;
};

export type QueryAllEventsArgs = {
  before?: Maybe<Scalars['DateTime']>;
};

export type QueryAppointmentArgs = {
  id: Scalars['Float'];
};

export type QueryAppointmentTemplateArgs = {
  appointmentType: Scalars['String'];
  careType: Scalars['String'];
};

export type QueryAssessmentByKeyArgs = {
  assessmentKey: AssessmentKey;
};

export type QueryAssessmentForRequestArgs = {
  requestId: Scalars['Float'];
};

export type QueryAuthInstructionsForEmailArgs = {
  app?: Maybe<SamlUserApp>;
  email: Scalars['String'];
  type?: Maybe<SamlConfigurationType>;
};

export type QueryAvailabilityArgs = {
  careType?: Maybe<Scalars['String']>;
  checkin?: Maybe<Scalars['Boolean']>;
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type QueryCareTeamChannelsArgs = {
  providerId?: Maybe<Scalars['Float']>;
};

export type QueryCheckRegistrationValidityArgs = {
  email: Scalars['String'];
};

export type QueryCrisisReportsZipArgs = {
  ddhFileSuccessId: Scalars['Int'];
};

export type QueryDebugCareFlowsForUserArgs = {
  userId: Scalars['Float'];
};

export type QueryDebugDataSharingConsentsForUserArgs = {
  userId: Scalars['Float'];
};

export type QueryDebugDataSharingRequestsForUserArgs = {
  userId: Scalars['Float'];
};

export type QueryDoesProviderNeedToReactivateUserCareTypeArgs = {
  careType: CareType;
  userId: Scalars['Float'];
};

export type QueryEmbedPatientArgs = {
  patientId: Scalars['Float'];
};

export type QueryEmbedPatientIdFromHealthieIdArgs = {
  healthieId: Scalars['String'];
};

export type QueryEventsArgs = {
  userId: Scalars['Float'];
};

export type QueryFetchProviderFeedbackTemplateArgs = {
  careType: Scalars['String'];
  feedbackType: FeedbackType;
  providerId: Scalars['Int'];
};

export type QueryFindCareStartArgs = {
  questionnaireKey: Scalars['String'];
};

export type QueryGenericCollegeModalArgs = {
  orgId: Scalars['Float'];
};

export type QueryGetAllCompletedSkillsForModuleArgs = {
  moduleId: Scalars['String'];
};

export type QueryGetAllNotesAndFormSubmissionsForUserArgs = {
  userId: Scalars['Float'];
};

export type QueryGetAllNotesForUserArgs = {
  userId: Scalars['Float'];
};

export type QueryGetClaimArgs = {
  id: Scalars['Float'];
};

export type QueryGetClaimsArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type QueryGetCoachChatMessagesArgs = {
  coachingProgramId?: Maybe<Scalars['Float']>;
  offset?: Maybe<Scalars['Float']>;
};

export type QueryGetEligibilityCarePeriodValuesArgs = {
  submissionId: Scalars['Float'];
};

export type QueryGetEligibilityResultArgs = {
  submissionId: Scalars['Float'];
};

export type QueryGetMySkillsAssignmentsArgs = {
  page: Scalars['Float'];
  perPage: Scalars['Float'];
};

export type QueryGetNoteByUuidArgs = {
  uuid: Scalars['String'];
};

export type QueryGetPossibleAssigneesArgs = {
  ticketId?: Maybe<Scalars['Float']>;
  userId: Scalars['Float'];
};

export type QueryGetSkillsAssignedToUserArgs = {
  page: Scalars['Float'];
  perPage: Scalars['Float'];
  userId: Scalars['Float'];
};

export type QueryGetUpNextSkillArgs = {
  isPathway: Scalars['Boolean'];
  moduleId: Scalars['String'];
  skillId: Scalars['String'];
};

export type QueryGetUpNextSkillForModuleArgs = {
  moduleId: Scalars['String'];
};

export type QueryHasSkillBeenStartedArgs = {
  input: SkillCompletionInputModel;
};

export type QueryHealthieProviderSyncedArgs = {
  id: Scalars['Float'];
};

export type QueryHubAppointmentByIdArgs = {
  appointmentId: Scalars['String'];
};

export type QueryIsSkillCompleteArgs = {
  input: SkillCompletionInputModel;
};

export type QueryLatestAssessmentArgs = {
  key: AssessmentKey;
};

export type QueryLoadUnfinishedSkillReflectionArgs = {
  skillId: Scalars['String'];
};

export type QueryMedicationsForUserArgs = {
  userId: Scalars['Float'];
};

export type QueryNextAvailableAppointmentArgs = {
  appointmentType: Scalars['String'];
  careType: CareType;
  organizationId: Scalars['Float'];
  startDate: Scalars['String'];
  userId?: Maybe<Scalars['Float']>;
};

export type QueryOnDemandOrgSessionsArgs = {
  params: OnDemandReportsInput;
};

export type QueryOrganizationArgs = {
  id: Scalars['Float'];
};

export type QueryOrganizationAnnouncementsByDaysArgs = {
  days?: Maybe<Scalars['Float']>;
  organizationId: Scalars['Float'];
};

export type QueryOrganizationAnnouncementsByOrgIdArgs = {
  limit?: Maybe<Scalars['Float']>;
  organizationId: Scalars['Float'];
};

export type QueryOrganizationCampusTeamArgs = {
  organizationId: Scalars['Float'];
};

export type QueryOrganizationHandbookArgs = {
  organizationId: Scalars['Float'];
};

export type QueryPaginatedUsersArgs = {
  params: UserListParams;
};

export type QueryPatientsArgs = {
  providerId: Scalars['Float'];
};

export type QueryPrivateChannelsArgs = {
  providerId?: Maybe<Scalars['Float']>;
};

export type QueryProviderByIdArgs = {
  id: Scalars['Float'];
};

export type QueryProviderEmailsArgs = {
  providerId: Scalars['Float'];
};

export type QueryProviderNetworkSearchArgs = {
  careType: CareType;
  doesOrgUseDGM?: Maybe<Scalars['Boolean']>;
  gender?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Float']>;
  payerId?: Maybe<Scalars['Float']>;
  state?: Maybe<StateCodes>;
  traits?: Maybe<Array<ProviderTraitInput>>;
  userId?: Maybe<Scalars['Float']>;
};

export type QueryProvidersArgs = {
  roles?: Maybe<Array<Scalars['String']>>;
};

export type QueryProviderSafetyPlansArgs = {
  incomplete?: Maybe<Scalars['Boolean']>;
};

export type QueryProvidersByIdArgs = {
  ids: Array<Scalars['Int']>;
};

export type QueryProvidersForUserArgs = {
  userId?: Maybe<Scalars['Float']>;
};

export type QueryRemainingHoursForRangeArgs = {
  appointmentType: Scalars['String'];
  careType: CareType;
  end: Scalars['String'];
  organizationId: Scalars['Float'];
  start: Scalars['String'];
};

export type QuerySafetyPlansArgs = {
  complete?: Maybe<Scalars['Boolean']>;
};

export type QuerySearchPharmacyArgs = {
  query: Scalars['String'];
};

export type QuerySearchPharmacyByAddressArgs = {
  address: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type QuerySearchUsersArgs = {
  search: SearchUserInput;
};

export type QuerySkillReflectionGetAllForUserArgs = {
  page: Scalars['Float'];
  perPage: Scalars['Float'];
};

export type QuerySkillReflectionGetUserAnswersArgs = {
  reflectionId: Scalars['Float'];
};

export type QueryTicketArgs = {
  id: Scalars['Float'];
};

export type QueryTicketsArgs = {
  userId?: Maybe<Scalars['Float']>;
  view: TicketView;
};

export type QueryUpcomingHubAppointmentArgs = {
  delay?: Maybe<Scalars['Float']>;
};

export type QueryUserCoachingHealthieStatusArgs = {
  userId: Scalars['Float'];
};

export type QueryUserEmailsArgs = {
  userId: Scalars['Int'];
};

export type QueryUserHealthieStatusArgs = {
  userId: Scalars['Float'];
};

export type QueryUserOutreachAttemptsArgs = {
  userId: Scalars['Int'];
};

export type QueryUserReferralStatusArgs = {
  userId: Scalars['Float'];
};

export type QueryUsersArgs = {
  includeNewPatients?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Float']>;
};

export type QueryUserSkillFeedbackArgs = {
  skillId: Scalars['String'];
};

export type QueryUserSmsesArgs = {
  userId: Scalars['Int'];
};

export type QueryUsersOrganizationsArgs = {
  params: UserListParams;
};

export type QueryWeeklyCapacityUsageArgs = {
  organizationId?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  weeks: Scalars['Int'];
};

export type QueryZendeskLinkArgs = {
  userId: Scalars['Float'];
};

export interface Question {
  caption?: Maybe<Scalars['String']>;
  dependency?: Maybe<Dependency>;
  disclaimer?: Maybe<Scalars['String']>;
  examples?: Maybe<Array<Scalars['String']>>;
  isOptional?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  legend?: Maybe<Array<Scalars['String']>>;
  manualInput?: Maybe<ManualInput>;
  options?: Maybe<Array<Option>>;
  overrideDescription?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  preText?: Maybe<Scalars['String']>;
  subText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
}

export interface Questionnaire {
  description?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  preScreen?: Maybe<QuestionnairePreScreen>;
  questions: Array<Question>;
  title: Scalars['String'];
}

export interface QuestionnairePreScreen {
  asset?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<SectionCopy>;
  title?: Maybe<Scalars['String']>;
}

export interface QuestionnaireResult {
  answers: Array<Answer>;
  assessment: AssessmentResponse;
  description: Scalars['String'];
  key: Scalars['String'];
  maximumScore?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  symptoms?: Maybe<Scalars['String']>;
}

export interface QuestionnaireSubmission {
  answers: Array<AnswerSubmission>;
  key: Scalars['String'];
}

export const ReactivationType = {
  Confirm: 'confirm',
  Reactivate: 'reactivate',
} as const;

export type ReactivationType = typeof ReactivationType[keyof typeof ReactivationType];
export const RecommendationOptions = {
  AssessmentVisit: 'assessmentVisit',
  Coaching: 'coaching',
  Therapy: 'therapy',
} as const;

export type RecommendationOptions =
  typeof RecommendationOptions[keyof typeof RecommendationOptions];
export interface RecommendationStatusForUserResponse {
  activeRecommendation: Scalars['Boolean'];
  expiration?: Maybe<Scalars['DateTime']>;
  isActiveOrOnboardingInCare: Scalars['Boolean'];
  isActiveOrOnboardingInTherapy: Scalars['Boolean'];
}

export const ReenrollmentStatus = {
  Cancelled: 'Cancelled',
  Confirmed: 'Confirmed',
  Declined: 'Declined',
  Pending: 'Pending',
} as const;

export type ReenrollmentStatus = typeof ReenrollmentStatus[keyof typeof ReenrollmentStatus];
/** App where the user originated */
export const ReferralSource = {
  Mcp: 'MCP',
  Oz: 'OZ',
  Portal: 'PORTAL',
} as const;

export type ReferralSource = typeof ReferralSource[keyof typeof ReferralSource];
export interface ReflectionPagination {
  page: Scalars['Float'];
  totalPages: Scalars['Float'];
}

export interface RegistrationValidity {
  emailAlreadyExists: Scalars['Boolean'];
  emailIsEligibleForOrganization: Scalars['Boolean'];
  emailMatchesOrganization: Scalars['Boolean'];
  organizationAllowsSelfReferral: Scalars['Boolean'];
  patientPortalInitialized: Scalars['Boolean'];
}

export interface RemainingHours {
  date: Scalars['String'];
  dgmAllocationId?: Maybe<Scalars['Int']>;
  remainingHours: Scalars['Float'];
}

/** Scope of report generated */
export const ReportScope = {
  All: 'ALL',
  Dtc: 'DTC',
  Org: 'ORG',
} as const;

export type ReportScope = typeof ReportScope[keyof typeof ReportScope];
export interface RequiredIf {
  dependentQuestions: Array<DependentQuestions>;
}

export const ResourceTag = {
  ByAppointment: 'ByAppointment',
  InPerson: 'InPerson',
  NonEmergencies: 'NonEmergencies',
  Open247: 'Open247',
  Telehealth: 'Telehealth',
} as const;

export type ResourceTag = typeof ResourceTag[keyof typeof ResourceTag];
export const ResourceType = {
  AcademicAndAccessibility: 'AcademicAndAccessibility',
  Additional: 'Additional',
  DisabilityAccessibilityCenter: 'DisabilityAccessibilityCenter',
  Diversity: 'Diversity',
  Emergency: 'Emergency',
  Health: 'Health',
  HealthServices: 'HealthServices',
  LgbtqiaCenter: 'LgbtqiaCenter',
  LocalHospitalCommunityProvider: 'LocalHospitalCommunityProvider',
  Other: 'Other',
  PreferredCampusPharmacy: 'PreferredCampusPharmacy',
  PublicSafetyCampusPolice: 'PublicSafetyCampusPolice',
  ResidenceLife: 'ResidenceLife',
  Safety: 'Safety',
  UrgentCareCenter: 'UrgentCareCenter',
} as const;

export type ResourceType = typeof ResourceType[keyof typeof ResourceType];
export const Role = {
  Admin: 'admin',
  Patient: 'patient',
  ProductAdmin: 'productAdmin',
  Provider: 'provider',
  Supreme: 'supreme',
  UniversityAdmin: 'universityAdmin',
  UniversityReferrer: 'universityReferrer',
  UniversityStaff: 'universityStaff',
  UniversitySupportingClinician: 'universitySupportingClinician',
} as const;

export type Role = typeof Role[keyof typeof Role];
export interface SafetyInfo {
  commonSideEffects: Array<SideEffect>;
  faq: Array<FaQuestion>;
  potentiallySeriousSideEffects: Array<SideEffect>;
  warning: Scalars['String'];
}

export interface SafetyPlan {
  activatingProvider: Provider;
  complete: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  data: SafetyPlanData;
  editHistory: Array<Event>;
  id: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  user: User;
}

export interface SafetyPlanContact {
  address?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  name: Scalars['String'];
}

export interface SafetyPlanData {
  copingStrategies: Array<Scalars['String']>;
  crisisContacts: Array<SafetyPlanContact>;
  crisisFacilities: Array<SafetyPlanContact>;
  crisisResources: Array<SafetyPlanContact>;
  dangerousMeans?: Maybe<Scalars['Boolean']>;
  dangerousMeansList?: Maybe<Scalars['String']>;
  dangerousMeansPlan?: Maybe<Scalars['String']>;
  distractions: Array<SafetyPlanContact>;
  firearmAccess?: Maybe<Scalars['Boolean']>;
  firearmAccessPlan?: Maybe<Scalars['String']>;
  professionalContacts: Array<SafetyPlanContact>;
  reasonToLive?: Maybe<Scalars['String']>;
  warningSigns: Array<Scalars['String']>;
}

export interface SafetyPlanInput {
  copingStrategies: Array<Scalars['String']>;
  crisisContacts: Array<SafetyPlanQuestionInput>;
  crisisFacilities: Array<SafetyPlanQuestionInput>;
  crisisResources: Array<SafetyPlanQuestionInput>;
  dangerousMeans?: Maybe<Scalars['Boolean']>;
  dangerousMeansList?: Maybe<Scalars['String']>;
  dangerousMeansPlan?: Maybe<Scalars['String']>;
  distractions: Array<SafetyPlanQuestionInput>;
  firearmAccess?: Maybe<Scalars['Boolean']>;
  firearmAccessPlan?: Maybe<Scalars['String']>;
  professionalContacts: Array<SafetyPlanQuestionInput>;
  reasonToLive?: Maybe<Scalars['String']>;
  warningSigns: Array<Scalars['String']>;
}

export interface SafetyPlanQuestionInput {
  address?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  name: Scalars['String'];
}

export interface SamlConfiguration {
  authnRequestBinding?: Maybe<Scalars['String']>;
  automaticallyUpdateEmail: Scalars['Boolean'];
  certificates: Array<Scalars['String']>;
  disableRequestedAuthnContext: Scalars['Boolean'];
  enableManualUniqueIdEdits: Scalars['Boolean'];
  entryPoint: Scalars['String'];
  id: Scalars['Int'];
  issuer?: Maybe<Scalars['String']>;
  metadata: Scalars['String'];
  profileEmailField: Scalars['String'];
  profileMatchingField: Scalars['String'];
  profileUniqueIdField?: Maybe<Scalars['String']>;
}

export const SamlConfigurationType = {
  Provider: 'Provider',
  User: 'User',
} as const;

export type SamlConfigurationType =
  typeof SamlConfigurationType[keyof typeof SamlConfigurationType];
export const SamlUserApp = {
  Hub: 'Hub',
  HubAndroid: 'HubAndroid',
  HubiOs: 'HubiOS',
  Portal: 'Portal',
} as const;

export type SamlUserApp = typeof SamlUserApp[keyof typeof SamlUserApp];
export interface SatisfactionRating {
  averageRating?: Maybe<Scalars['Float']>;
  numberOfRatings: Scalars['Float'];
}

export interface ScreenUserResult {
  screenedOut: Scalars['Boolean'];
  screenedOutFromHub: Scalars['Boolean'];
}

export interface ScreenUserResultInput {
  screenedOut: Scalars['Boolean'];
  screenedOutFromHub?: Maybe<Scalars['Boolean']>;
}

export interface SearchUserInput {
  careStatus?: Maybe<CareStatus>;
  createdAfter?: Maybe<Scalars['DateTime']>;
  createdBefore?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['String']>;
}

export const SectionColor = {
  BrandAltBg: 'brandAltBg',
  DangerBg: 'dangerBg',
  GreyBg: 'greyBg',
} as const;

export type SectionColor = typeof SectionColor[keyof typeof SectionColor];
export type SectionCopy = ListCopy | TextCopy;

/** Change behavior based on another section */
export interface SectionDependency {
  key: Scalars['String'];
  /** only show if question has values */
  showValues?: Maybe<Array<Scalars['String']>>;
}

export const SectionFormat = {
  Appointment: 'appointment',
  Checkbox: 'checkbox',
  Date: 'date',
  Diagnosis: 'diagnosis',
  Formtexttitle: 'formtexttitle',
  Multicheckbox: 'multicheckbox',
  Multidiagnosis: 'multidiagnosis',
  Multiselect: 'multiselect',
  Multitext: 'multitext',
  Radio: 'radio',
  Rx: 'rx',
  Scale: 'scale',
  Select: 'select',
  Sign: 'sign',
  Singlelineinput: 'singlelineinput',
  Textarea: 'textarea',
  Title: 'title',
} as const;

export type SectionFormat = typeof SectionFormat[keyof typeof SectionFormat];
export interface SectionHook {
  targetKey: Scalars['String'];
  type: HookType;
}

/** Auto-select a value based on another value */
export interface SelectDependentValue {
  /** trigger selection if one of these values */
  dependsValues?: Maybe<Array<Scalars['String']>>;
  targetKey: Scalars['String'];
  /** the value to be selected */
  targetSelectValue?: Maybe<Scalars['String']>;
}

export interface SendCoachChatMessageResult {
  id?: Maybe<Scalars['String']>;
}

export interface SentEmail {
  bounced: Scalars['Boolean'];
  clicked: Scalars['Boolean'];
  delivered: Scalars['Boolean'];
  id: Scalars['Float'];
  label: Scalars['String'];
  opened: Scalars['Boolean'];
  outcome?: Maybe<Scalars['String']>;
  sent: Scalars['Boolean'];
  sentAt: Scalars['DateTime'];
  subject: Scalars['String'];
  template: Scalars['String'];
  unsubscribed: Scalars['Boolean'];
}

export interface SentSmsModel {
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  template?: Maybe<Scalars['String']>;
}

export interface ServiceCoupon {
  active: Scalars['Boolean'];
  autoApplyOnConversion: Scalars['Boolean'];
  careTypes: Array<CareType>;
  code: Scalars['String'];
  discountType: DiscountType;
  id: Scalars['Float'];
  maxUses: Scalars['Float'];
  organization?: Maybe<Organization>;
  percentDiscount?: Maybe<Scalars['Float']>;
  replacePriceCents?: Maybe<Scalars['Int']>;
}

export interface SideEffect {
  explanation: Scalars['String'];
  title: Scalars['String'];
}

export interface SignedS3Upload {
  fields: Array<Array<Scalars['String']>>;
  key: Scalars['String'];
  url: Scalars['String'];
}

export interface SkillAssignmentCountsResponse {
  notCompleted: Scalars['Int'];
  notSeen: Scalars['Int'];
}

export interface SkillAssignmentModel {
  assignedById: Scalars['Int'];
  assignerHasSeen: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  moduleId: Scalars['String'];
  skillId: Scalars['String'];
  skillReflection?: Maybe<SkillReflectionAnswers>;
  skillTitle: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  userHasSeen: Scalars['Boolean'];
  userId: Scalars['Int'];
}

export interface SkillCompletionInputModel {
  moduleId: Scalars['String'];
  sectionId?: Maybe<Scalars['String']>;
  skillId: Scalars['String'];
}

export interface SkillFeedbackModel {
  additionalFeedback?: Maybe<Scalars['String']>;
  rating: Scalars['Float'];
}

export interface SkillFeedbackQuestionModelInput {
  questionSlug: Scalars['String'];
  response: Scalars['Float'];
}

export interface SkillPathwayAnswer {
  moduleId: Scalars['String'];
  nudgeIds: Array<Scalars['String']>;
  score: Scalars['Float'];
  sectionId: Scalars['String'];
}

export interface SkillPathwayNextSkill {
  hasPathway: Scalars['Boolean'];
  moduleId?: Maybe<Scalars['String']>;
  nextSkillId?: Maybe<Scalars['String']>;
  sectionId?: Maybe<Scalars['String']>;
}

export interface SkillPathwayNudge {
  id: Scalars['String'];
  name: Scalars['String'];
}

export interface SkillPathwayStep {
  moduleId: Scalars['String'];
  nudges: Array<SkillPathwayNudge>;
  score: Scalars['Float'];
  sectionId: Scalars['String'];
}

export interface SkillReflection {
  id: Scalars['Float'];
  isComplete: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
}

export interface SkillReflectionAnswers {
  id: Scalars['Float'];
  questions: Array<SkillReflectionQuestion>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
}

export interface SkillReflectionQuestion {
  answer: Scalars['String'];
  question: Scalars['String'];
  questionKey: Scalars['String'];
}

export const SortDirection = {
  Ascending: 'Ascending',
  Descending: 'Descending',
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
export interface SpecialConditions {
  bipolarSchizophrenia: Scalars['Boolean'];
  suicidal: Scalars['Boolean'];
}

export const SponsoredSessionsLimitType = {
  ShortTermCapped: 'shortTermCapped',
  ShortTermUncapped: 'shortTermUncapped',
  StudentAssistanceProgram: 'studentAssistanceProgram',
  Unrestricted: 'unrestricted',
} as const;

export type SponsoredSessionsLimitType =
  typeof SponsoredSessionsLimitType[keyof typeof SponsoredSessionsLimitType];
export const StateCodes = {
  Ak: 'AK',
  Al: 'AL',
  Ar: 'AR',
  As: 'AS',
  Az: 'AZ',
  Ca: 'CA',
  Co: 'CO',
  Ct: 'CT',
  Dc: 'DC',
  De: 'DE',
  Fl: 'FL',
  Fm: 'FM',
  Ga: 'GA',
  Gu: 'GU',
  Hi: 'HI',
  Ia: 'IA',
  Id: 'ID',
  Il: 'IL',
  In: 'IN',
  Ks: 'KS',
  Ky: 'KY',
  La: 'LA',
  Ma: 'MA',
  Md: 'MD',
  Me: 'ME',
  Mh: 'MH',
  Mi: 'MI',
  Mn: 'MN',
  Mo: 'MO',
  Mp: 'MP',
  Ms: 'MS',
  Mt: 'MT',
  Nc: 'NC',
  Nd: 'ND',
  Ne: 'NE',
  Nh: 'NH',
  Nj: 'NJ',
  Nm: 'NM',
  Nv: 'NV',
  Ny: 'NY',
  Oh: 'OH',
  Ok: 'OK',
  Or: 'OR',
  Pa: 'PA',
  Pr: 'PR',
  Pw: 'PW',
  Ri: 'RI',
  Sc: 'SC',
  Sd: 'SD',
  Tn: 'TN',
  Tx: 'TX',
  Ut: 'UT',
  Va: 'VA',
  Vi: 'VI',
  Vt: 'VT',
  Wa: 'WA',
  Wi: 'WI',
  Wv: 'WV',
  Wy: 'WY',
} as const;

export type StateCodes = typeof StateCodes[keyof typeof StateCodes];
export interface Subscription {
  coachChatUpdates: CoachChatUpdate;
  portalUpdates: Array<PortalKey>;
}

export type SubscriptionCoachChatUpdatesArgs = {
  coachingProgramId?: Maybe<Scalars['Float']>;
};

/** The different kinds of suicidal thoughts */
export const SuicidalThoughts = {
  DuringMyLifetime: 'DURING_MY_LIFETIME',
  Never: 'NEVER',
  WithinThePastMonth: 'WITHIN_THE_PAST_MONTH',
  WithinThePastYear: 'WITHIN_THE_PAST_YEAR',
} as const;

export type SuicidalThoughts = typeof SuicidalThoughts[keyof typeof SuicidalThoughts];
export interface Task {
  blueprintId: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  done: Scalars['Boolean'];
  id: Scalars['Int'];
  ref: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Float'];
}

export const TaskStatusFilter = {
  Cancelled: 'Cancelled',
  Discharged: 'Discharged',
  Intake: 'Intake',
  OngoingCare: 'OngoingCare',
  OnHold: 'OnHold',
  ScreenedOut: 'ScreenedOut',
} as const;

export type TaskStatusFilter = typeof TaskStatusFilter[keyof typeof TaskStatusFilter];
export interface TestVideoSession {
  videoSessionId: Scalars['String'];
  videoToken: Scalars['String'];
}

export interface TextCopy {
  showInView?: Maybe<Scalars['Boolean']>;
  style?: Maybe<TextStyle>;
  text: Scalars['String'];
}

export const TextKind = {
  Danger: 'danger',
} as const;

export type TextKind = typeof TextKind[keyof typeof TextKind];
export interface TextStyle {
  italic?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<TextKind>;
  tag?: Maybe<TextTag>;
}

export const TextTag = {
  Body: 'body',
  BodyBold: 'bodyBold',
  BodyGrey: 'bodyGrey',
  Bodysmall: 'bodysmall',
  BodySmallBold: 'bodySmallBold',
  Caption: 'caption',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  Label: 'label',
} as const;

export type TextTag = typeof TextTag[keyof typeof TextTag];
export interface Ticket {
  assignee?: Maybe<Provider>;
  assignOptions: TicketAssignOption;
  blockedReason?: Maybe<Scalars['String']>;
  canEdit: Scalars['Boolean'];
  canResolve: Scalars['Boolean'];
  category: TicketCategory;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  events: Array<Event>;
  id: Scalars['Int'];
  priority?: Maybe<TicketPriority>;
  requester?: Maybe<Provider>;
  resolveIn24Hrs?: Maybe<Scalars['Boolean']>;
  status: TicketStatus;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
}

export const TicketAssignOption = {
  Any: 'Any',
  None: 'None',
  Self: 'Self',
} as const;

export type TicketAssignOption = typeof TicketAssignOption[keyof typeof TicketAssignOption];
export const TicketCategory = {
  Coc: 'coc',
  DatasharingCoc: 'datasharingCoc',
  DatasharingRoi: 'datasharingRoi',
  Insurance: 'insurance',
  Labs: 'labs',
  OnHold: 'onHold',
  Other: 'other',
  Outreach: 'outreach',
  PriorAuth: 'priorAuth',
  ReferralOther: 'referralOther',
  ReferralPsychiatry: 'referralPsychiatry',
  ReferralTherapy: 'referralTherapy',
  Scheduling: 'scheduling',
  TechSupport: 'techSupport',
} as const;

export type TicketCategory = typeof TicketCategory[keyof typeof TicketCategory];
export const TicketPriority = {
  High: 'High',
  Low: 'Low',
  Medium: 'Medium',
} as const;

export type TicketPriority = typeof TicketPriority[keyof typeof TicketPriority];
export const TicketStatus = {
  Active: 'Active',
  Blocked: 'Blocked',
  Complete: 'Complete',
  Deleted: 'Deleted',
} as const;

export type TicketStatus = typeof TicketStatus[keyof typeof TicketStatus];
export const TicketView = {
  Active: 'Active',
  AssignedToMe: 'AssignedToMe',
  Blocked: 'Blocked',
  New: 'New',
  Resolved: 'Resolved',
  Unresolved: 'Unresolved',
} as const;

export type TicketView = typeof TicketView[keyof typeof TicketView];
export const TimeAllocationPurpose = {
  Admin: 'Admin',
  Availability: 'Availability',
  TimeOff: 'TimeOff',
} as const;

export type TimeAllocationPurpose =
  typeof TimeAllocationPurpose[keyof typeof TimeAllocationPurpose];
export const TraitCategory = {
  Ethnicity: 'Ethnicity',
  Faith: 'Faith',
  Languages: 'Languages',
  Sexuality: 'Sexuality',
  Specialties: 'Specialties',
  TherapyTypes: 'TherapyTypes',
} as const;

export type TraitCategory = typeof TraitCategory[keyof typeof TraitCategory];
export interface TriageInfo {
  answers: Array<Answer>;
  assessmentId: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
}

/** Copy triggered on specific answers */
export interface TriggeredCopy {
  background?: Maybe<SectionColor>;
  border?: Maybe<SectionColor>;
  copy: Array<SectionCopy>;
  /** If depends on another key */
  dependsKey?: Maybe<Scalars['String']>;
  triggers: Array<Scalars['String']>;
}

export interface TwoFactorAuthResult {
  authToken?: Maybe<Scalars['String']>;
  codeValid: Scalars['Boolean'];
  deviceToken?: Maybe<Scalars['String']>;
}

export interface TwoFactorConfig {
  enabled: Scalars['Boolean'];
  id: Scalars['Float'];
  phone: Scalars['String'];
  phoneVerified: Scalars['Boolean'];
}

export interface UnfinishedSkillReflection {
  isComplete: Scalars['Boolean'];
  questions: Array<SkillReflectionQuestion>;
}

export const UniversityRelationship = {
  UniversityCollaborator: 'universityCollaborator',
  UniversityMonitor: 'universityMonitor',
} as const;

export type UniversityRelationship =
  typeof UniversityRelationship[keyof typeof UniversityRelationship];
export interface UpdateCoupon {
  active: Scalars['Boolean'];
  autoApplyOnConversion: Scalars['Boolean'];
  careTypes: Array<CareType>;
  code: Scalars['String'];
  discountType: DiscountType;
  id?: Maybe<Scalars['Int']>;
  maxUses: Scalars['Float'];
  organizationId?: Maybe<Scalars['Float']>;
  percentDiscount?: Maybe<Scalars['Float']>;
  replacePriceCents?: Maybe<Scalars['Int']>;
}

export interface UpdateFileUpload {
  globallyShared: Scalars['Boolean'];
  name: Scalars['String'];
  type: UploadType;
  uploadId: Scalars['Float'];
}

export interface UpdateOrganization {
  abbreviation?: Maybe<Scalars['String']>;
  departmentAddress?: Maybe<Scalars['String']>;
  departmentHours?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  directorId?: Maybe<Scalars['Int']>;
  emailDomains?: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
}

export interface UpdateOrganizationEntitlementInput {
  config?: Maybe<Scalars['JSON']>;
  enabled: Scalars['Boolean'];
  key: Entitlement;
}

export interface UpdatePayerParams {
  billToProviderName: Scalars['Boolean'];
  id?: Maybe<Scalars['Float']>;
  inNetworkStates: Array<Scalars['String']>;
  name: Scalars['String'];
  standardPayerId: Scalars['String'];
  stateAddressOverrides: Array<PayerStateAddressOverrideInput>;
  tradingPartnerId: Scalars['String'];
  useAddressForAllStates?: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
}

export interface UpdateProvider {
  activityStatus?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  dosespotId?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  funFact?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  geoStates?: Maybe<Array<Scalars['String']>>;
  id: Scalars['Float'];
  lastName?: Maybe<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  personalTitle?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postNominalTitles?: Maybe<Scalars['String']>;
  pronouns?: Maybe<Scalars['String']>;
  providerType?: Maybe<Scalars['String']>;
  role?: Maybe<UpdateStaffRole>;
}

export interface UpdateProviderStateAllocationsModelInput {
  id: Scalars['Int'];
  maxHours: Scalars['Float'];
  maxIntakeHours: Scalars['Float'];
}

export interface UpdateSamlConfiguration {
  authnRequestBinding?: Maybe<Scalars['String']>;
  automaticallyUpdateEmail: Scalars['Boolean'];
  certificates: Array<Scalars['String']>;
  disableRequestedAuthnContext: Scalars['Boolean'];
  enableManualUniqueIdEdits: Scalars['Boolean'];
  entryPoint: Scalars['String'];
  issuer?: Maybe<Scalars['String']>;
  profileEmailField: Scalars['String'];
  profileMatchingField?: Maybe<Scalars['String']>;
  profileUniqueIdField: Scalars['String'];
}

export const UpdateStaffRole = {
  UniversityAdmin: 'universityAdmin',
  UniversityReferrer: 'universityReferrer',
  UniversityStaff: 'universityStaff',
  UniversitySupportingClinician: 'universitySupportingClinician',
} as const;

export type UpdateStaffRole = typeof UpdateStaffRole[keyof typeof UpdateStaffRole];
export interface UpdateUserInput {
  authToken?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<AddressInput>;
  birthDate?: Maybe<Scalars['String']>;
  cardToken?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  organizationIdentification?: Maybe<Scalars['String']>;
  pharmacyId?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  primaryAddress?: Maybe<AddressInput>;
  pronouns?: Maybe<Scalars['String']>;
  secondaryState?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
}

export interface Upload {
  canEdit?: Maybe<Scalars['Boolean']>;
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByProvider?: Maybe<Provider>;
  globallyShared?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  name: Scalars['String'];
  type: UploadType;
  url: Scalars['String'];
}

export const UploadType = {
  InsuranceDetails: 'InsuranceDetails',
  LabResults: 'LabResults',
  Other: 'Other',
  PatientResource: 'PatientResource',
  ReferralNote: 'ReferralNote',
} as const;

export type UploadType = typeof UploadType[keyof typeof UploadType];
export interface UpsertProviderInsuranceCredential {
  active: Scalars['Boolean'];
  payerId: Scalars['Float'];
  providerId: Scalars['Float'];
  state: Scalars['String'];
}

export interface UseOtherApp {
  name: Scalars['String'];
  roleDescription: Scalars['String'];
  url: Scalars['String'];
}

export interface User {
  adminAlerts: Array<AdminAlert>;
  appointmentTemplates: Array<AppointmentTemplate>;
  assessmentInfo: UserAssessmentInfo;
  authToken?: Maybe<Scalars['String']>;
  /** get first of each questionnaire taken by the user */
  baselineQuestionnaires: Array<QuestionnaireResult>;
  billingAddress?: Maybe<Address>;
  birthDate?: Maybe<Scalars['Date']>;
  campusTeam?: Maybe<Array<CampusTeamRelationship>>;
  careFlows: Array<UserCareFlow>;
  careStatus: CareStatus;
  careTeam: Array<Provider>;
  careTeamChannel: Channel;
  careTransitions: Array<ContinuityOfCareModel>;
  careTypes: Array<CareType>;
  cocEligibility: Array<ContinuityOfCareEligibilityValidation>;
  /** Care eligibility form responses for continuity of care */
  continuityOfCareEligibility: Array<ContinuityOfCareEligibilityModel>;
  continuityOfCareTransitions: Array<ContinuityOfCareModel>;
  createdAt: Scalars['DateTime'];
  customerId?: Maybe<Scalars['String']>;
  dataSharingConsent?: Maybe<DataSharingConsent>;
  dataSharingRequest?: Maybe<DataSharingRequest>;
  editableFields: Array<EditableUserFields>;
  email: Scalars['String'];
  /** Returns email if the requester has permission to see it, and null otherwise. Helpful for user lists. */
  emailIfVisible?: Maybe<Scalars['String']>;
  emailVerified: Scalars['Boolean'];
  emergencyContacts: Array<Contact>;
  engagementTags: Array<EngagementTag>;
  firstName: Scalars['String'];
  flaggedForOutreachAt?: Maybe<Scalars['DateTime']>;
  hasADHD: Scalars['Boolean'];
  hasAnxiety: Scalars['Boolean'];
  hasDepression: Scalars['Boolean'];
  hasDosespot: Scalars['Boolean'];
  /** Get insurance eligibility without restricted check */
  hasEligibleInsurance: Scalars['Boolean'];
  hasOutstandingPrescription: Scalars['Boolean'];
  hasPaymentMethod: Scalars['Boolean'];
  hasProvider: Scalars['Boolean'];
  hasSafetyPlan: Scalars['Boolean'];
  hasSso?: Maybe<Scalars['Boolean']>;
  hasSubscription?: Maybe<Scalars['Boolean']>;
  hasTherapist: Scalars['Boolean'];
  hubOnboardingStatus?: Maybe<HubStatusForUser>;
  id: Scalars['Int'];
  identificationCard?: Maybe<Upload>;
  identityVerified: Scalars['Boolean'];
  insuranceDetails?: Maybe<InsuranceDetails>;
  insuranceDetailsIfBookingForSelfPayPatient?: Maybe<InsuranceDetails>;
  insuranceDetailsIfVisible?: Maybe<InsuranceDetails>;
  intakeComplete: Scalars['Boolean'];
  /** makes stripe request */
  invoices: Array<Invoice>;
  isPaymentMethodValid: Scalars['Boolean'];
  isTherapyOnboarding: Scalars['Boolean'];
  lastAppointment?: Maybe<CalendarEvent>;
  lastName: Scalars['String'];
  /** Last manual outreach made for this user */
  lastOutreachAttempt?: Maybe<Scalars['DateTime']>;
  lastPrescriptionWrittenDate?: Maybe<Scalars['DateTime']>;
  latestMedicalHistoryResult?: Maybe<MedicalHistory>;
  /** get latest of each questionnaire taken by the user */
  latestQuestionnaires: Array<QuestionnaireResult>;
  mantraAdminCareTeam: Array<Provider>;
  needsScales: Scalars['Boolean'];
  nextAppointment?: Maybe<CalendarEvent>;
  nextAppointmentTime?: Maybe<Scalars['DateTime']>;
  nextScales?: Maybe<Scalars['DateTime']>;
  notes: Array<MedicalNote>;
  onHoldOrActiveCareTypes: Array<CareType>;
  organization?: Maybe<Organization>;
  organizationIdentification?: Maybe<Scalars['String']>;
  origin: UserOrigin;
  /** makes stripe request */
  paymentInfo?: Maybe<PaymentProfile>;
  pendingSponsoredCareReenrollment: Scalars['Boolean'];
  phone?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  primaryAddress?: Maybe<Address>;
  /** state from primaryAddress without restricted check */
  primaryAddressState?: Maybe<Scalars['String']>;
  primaryEmergencyContact?: Maybe<Contact>;
  privateChannel: Channel;
  privateChannels?: Maybe<Array<Channel>>;
  privateChannelWith?: Maybe<Channel>;
  pronouns?: Maybe<Scalars['String']>;
  provider?: Maybe<Provider>;
  providerForCareType?: Maybe<Provider>;
  providerIfVisible?: Maybe<Provider>;
  recordViewStatus: UserRecordViewStatus;
  referralComplete?: Maybe<Scalars['Boolean']>;
  referralSource: ReferralSource;
  referredByUniversityReferrer: Scalars['Boolean'];
  referringProvider?: Maybe<Provider>;
  safetyPlan?: Maybe<SafetyPlan>;
  samlUniqueId?: Maybe<Scalars['String']>;
  screenedOut?: Maybe<Scalars['Boolean']>;
  secondaryState?: Maybe<StateCodes>;
  selfie?: Maybe<Upload>;
  suggestedProviders: Array<Provider>;
  tasks?: Maybe<Array<Task>>;
  taskStatus: Scalars['String'];
  taskStatusIfVisible?: Maybe<Scalars['String']>;
  therapist?: Maybe<Provider>;
  therapistIfVisible?: Maybe<Provider>;
  timeZone?: Maybe<Scalars['String']>;
  triageInfo?: Maybe<Array<TriageInfo>>;
  unansweredMessagesCount: Scalars['Int'];
  universityCareTeam: Array<Provider>;
  universityCareTeamPrimary?: Maybe<Provider>;
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  uploads: Array<Upload>;
  verificationStatus: Scalars['String'];
}

export type UserLastAppointmentArgs = {
  appointmentType?: Maybe<AppointmentType>;
  careType: CareType;
  status?: Maybe<Scalars['String']>;
};

export type UserNextAppointmentArgs = {
  appointmentType?: Maybe<AppointmentType>;
  careType?: Maybe<CareType>;
  status?: Maybe<Scalars['String']>;
};

export type UserPrivateChannelArgs = {
  providerId?: Maybe<Scalars['Float']>;
};

export type UserPrivateChannelWithArgs = {
  kind: Scalars['String'];
};

export type UserProviderForCareTypeArgs = {
  careType: CareType;
};

export interface UserAssessmentInfo {
  additionalDiagnoses?: Maybe<Array<Scalars['String']>>;
  additionalProviderContact?: Maybe<Scalars['String']>;
  additionalProviderName?: Maybe<Scalars['String']>;
  allergies?: Maybe<Array<Scalars['String']>>;
  diagnoses?: Maybe<Array<Scalars['String']>>;
  medication?: Maybe<Array<Prescription>>;
  otherMeds?: Maybe<Array<Scalars['String']>>;
  primaryDiagnosis?: Maybe<Scalars['String']>;
  pronouns?: Maybe<Scalars['String']>;
  psychiatricHistory?: Maybe<Array<Scalars['String']>>;
  riskLevel?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  suicidal?: Maybe<Array<Scalars['String']>>;
  wellnessGoals?: Maybe<Array<Scalars['String']>>;
}

export interface UserCareFlow {
  /** Broad activity check without restricted permission */
  canBookAppointment: Scalars['Boolean'];
  careSessionInfo?: Maybe<CareSessionInfo>;
  careStatus: CareStatus;
  careType: CareType;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  organizationCareFlow?: Maybe<OrganizationCareFlow>;
  paymentSource: PaymentSource;
  pendingTransition?: Maybe<ContinuityOfCareModel>;
  providerStatesAvailable: Array<Scalars['String']>;
  taskStatus: Scalars['String'];
  updatedAt: Scalars['DateTime'];
}

export interface UserCareFlowInput {
  careStatus?: Maybe<CareStatus>;
  careType: CareType;
  paymentSource: PaymentSource;
  sessionLimitOverride?: Maybe<Scalars['Int']>;
}

export interface UserCoachingHealthieStatus {
  userCoachingHealthieStatus?: Maybe<CoachingStatus>;
}

export interface UserCoachingStatus {
  userCoachingStatus?: Maybe<CoachingStatus>;
}

export interface UserDemographics {
  academicProgram: Scalars['String'];
  createdAt: Scalars['DateTime'];
  ethnicity: Scalars['String'];
  genderIdentity: Scalars['String'];
  id: Scalars['Float'];
  isInternationalStudent: Scalars['Boolean'];
  sexualOrientation: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  yearInProgram: Scalars['String'];
}

export interface UserDiagnosis {
  category: Scalars['String'];
  code: Scalars['String'];
  key: Scalars['String'];
  subCategory?: Maybe<Scalars['String']>;
  userId: Scalars['Float'];
}

export interface UserHealthieStatus {
  userIsInitialized: Scalars['Boolean'];
}

export interface UserIsLoggedIn {
  authToken?: Maybe<Scalars['String']>;
  isLoggedIn: Scalars['Boolean'];
}

export interface UserListParams {
  careStatus?: Maybe<CareStatus>;
  careTeamMemberId?: Maybe<Scalars['Float']>;
  cursor?: Maybe<Scalars['String']>;
  dtc?: Maybe<Scalars['Boolean']>;
  excludeMyPatients?: Maybe<Scalars['Boolean']>;
  geoState?: Maybe<Scalars['String']>;
  includeAllPatients?: Maybe<Scalars['Boolean']>;
  includeNewPatients?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextSteps?: Maybe<NextStepsFilter>;
  organizationId?: Maybe<Scalars['Float']>;
  providerId?: Maybe<Scalars['Float']>;
  search?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<SortDirection>;
  sortField?: Maybe<Scalars['String']>;
  taskStatus?: Maybe<TaskStatusFilter>;
}

export const UserNotificationKey = {
  BipolarScreening: 'bipolarScreening',
  CompleteSafetyPlan: 'completeSafetyPlan',
  DataSharingRequest: 'dataSharingRequest',
  InvalidEmergencyContact: 'invalidEmergencyContact',
  InvalidPaymentMethod: 'invalidPaymentMethod',
  MonthlyScales: 'monthlyScales',
  PendingCareTransition: 'pendingCareTransition',
  PrescriptionSubmitted: 'prescriptionSubmitted',
  ProviderFeedback: 'providerFeedback',
  ReactivateSponsoredPsychiatry: 'reactivateSponsoredPsychiatry',
  ReactivateSponsoredTherapy: 'reactivateSponsoredTherapy',
  ScheduleAppointmentPsychiatry: 'scheduleAppointmentPsychiatry',
  ScheduleAppointmentTherapy: 'scheduleAppointmentTherapy',
  UnreadMessages: 'unreadMessages',
} as const;

export type UserNotificationKey = typeof UserNotificationKey[keyof typeof UserNotificationKey];
export const UserOrigin = {
  Dtc: 'Dtc',
  Student: 'Student',
} as const;

export type UserOrigin = typeof UserOrigin[keyof typeof UserOrigin];
export const UserRecordViewStatus = {
  Full: 'Full',
  Limited: 'Limited',
  Restricted: 'Restricted',
} as const;

export type UserRecordViewStatus = typeof UserRecordViewStatus[keyof typeof UserRecordViewStatus];
export interface UserSkillAssignments {
  pagination: AssignmentPagination;
  skillAssignments: Array<SkillAssignmentModel>;
}

export interface UserSkillReflections {
  pagination: ReflectionPagination;
  reflections: Array<SkillReflection>;
}

export interface UserSponsoredReactivation {
  careTypes: Array<CareType>;
  isSelfReactivationAllowed: Scalars['Boolean'];
  reactivationCopy?: Maybe<Scalars['String']>;
  userHasRemainingAppts: Scalars['Boolean'];
}

export interface UtilizationHours {
  hoursScheduled?: Maybe<Scalars['Float']>;
  hoursUtilized?: Maybe<Scalars['Float']>;
  intakesScheduled?: Maybe<Scalars['Float']>;
  intakesUtilized?: Maybe<Scalars['Float']>;
  maxHours?: Maybe<Scalars['Float']>;
  maxIntakeHours?: Maybe<Scalars['Int']>;
}

export interface UtilizationVirtualModel {
  carePeriod: OrganizationCarePeriodModel;
  weeklyUtilizationRecords: Array<OrganizationUtilizationWeek>;
}

export interface VisitAttendance {
  attendance: Array<NumericKeyValue>;
  carePeriod?: Maybe<OrganizationCarePeriodModel>;
}

export type EmbedPatientIdFromHealthieIdQueryVariables = Exact<{
  healthieId: Scalars['String'];
}>;

export type EmbedPatientIdFromHealthieIdQuery = { embedPatientIdFromHealthieId?: Maybe<number> };

export type EmbedPatientQueryVariables = Exact<{
  patientId: Scalars['Float'];
}>;

export type EmbedPatientQuery = {
  embedPatient?: Maybe<{ name: string; organization?: Maybe<{ name: string }> }>;
};

export type GetAssignableSkillsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAssignableSkillsQuery = {
  getAssignableSkills: Array<{ moduleId: string; skillId: string; title: string }>;
};

export type GetSkillsAssignedToUserQueryVariables = Exact<{
  userId: Scalars['Float'];
  page: Scalars['Float'];
  perPage: Scalars['Float'];
}>;

export type GetSkillsAssignedToUserQuery = {
  getSkillsAssignedToUser: {
    pagination: { page: number; totalPages: number };
    skillAssignments: Array<{
      id: number;
      userId: number;
      assignedById: number;
      skillId: string;
      moduleId: string;
      userHasSeen: boolean;
      assignerHasSeen: boolean;
      completedAt?: Maybe<string>;
      startedAt?: Maybe<string>;
      createdAt: string;
      skillTitle: string;
      skillReflection?: Maybe<{
        title: string;
        questions: Array<{ question: string; answer: string }>;
      }>;
    }>;
  };
};

export type AssignSkillToUserMutationVariables = Exact<{
  skillId: Scalars['String'];
  moduleId: Scalars['String'];
  userId: Scalars['Float'];
}>;

export type AssignSkillToUserMutation = {
  assignSkillToUser: { isDuplicate: boolean; wasAssigned: boolean };
};

export type MarkSkillAssignmentSeenByAssignerMutationVariables = Exact<{
  skillAssignmentId: Scalars['Float'];
}>;

export type MarkSkillAssignmentSeenByAssignerMutation = {
  markSkillAssignmentSeenByAssigner: boolean;
};

export type UnassignSkillFromUserMutationVariables = Exact<{
  skillAssignmentId: Scalars['Float'];
  userId: Scalars['Float'];
}>;

export type UnassignSkillFromUserMutation = { unassignSkillFromUser: boolean };

export const EmbedPatientIdFromHealthieIdDocument = gql`
  query embedPatientIdFromHealthieId($healthieId: String!) {
    embedPatientIdFromHealthieId(healthieId: $healthieId)
  }
`;

/**
 * __useEmbedPatientIdFromHealthieIdQuery__
 *
 * To run a query within a React component, call `useEmbedPatientIdFromHealthieIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbedPatientIdFromHealthieIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbedPatientIdFromHealthieIdQuery({
 *   variables: {
 *      healthieId: // value for 'healthieId'
 *   },
 * });
 */
export function useEmbedPatientIdFromHealthieIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EmbedPatientIdFromHealthieIdQuery,
    EmbedPatientIdFromHealthieIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    EmbedPatientIdFromHealthieIdQuery,
    EmbedPatientIdFromHealthieIdQueryVariables
  >(EmbedPatientIdFromHealthieIdDocument, options);
}
export function useEmbedPatientIdFromHealthieIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmbedPatientIdFromHealthieIdQuery,
    EmbedPatientIdFromHealthieIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    EmbedPatientIdFromHealthieIdQuery,
    EmbedPatientIdFromHealthieIdQueryVariables
  >(EmbedPatientIdFromHealthieIdDocument, options);
}
export type EmbedPatientIdFromHealthieIdQueryHookResult = ReturnType<
  typeof useEmbedPatientIdFromHealthieIdQuery
>;
export type EmbedPatientIdFromHealthieIdLazyQueryHookResult = ReturnType<
  typeof useEmbedPatientIdFromHealthieIdLazyQuery
>;
export type EmbedPatientIdFromHealthieIdQueryResult = ApolloReactCommon.QueryResult<
  EmbedPatientIdFromHealthieIdQuery,
  EmbedPatientIdFromHealthieIdQueryVariables
>;
export const EmbedPatientDocument = gql`
  query embedPatient($patientId: Float!) {
    embedPatient(patientId: $patientId) {
      name
      organization {
        name
      }
    }
  }
`;

/**
 * __useEmbedPatientQuery__
 *
 * To run a query within a React component, call `useEmbedPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbedPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbedPatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useEmbedPatientQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<EmbedPatientQuery, EmbedPatientQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<EmbedPatientQuery, EmbedPatientQueryVariables>(
    EmbedPatientDocument,
    options
  );
}
export function useEmbedPatientLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmbedPatientQuery, EmbedPatientQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<EmbedPatientQuery, EmbedPatientQueryVariables>(
    EmbedPatientDocument,
    options
  );
}
export type EmbedPatientQueryHookResult = ReturnType<typeof useEmbedPatientQuery>;
export type EmbedPatientLazyQueryHookResult = ReturnType<typeof useEmbedPatientLazyQuery>;
export type EmbedPatientQueryResult = ApolloReactCommon.QueryResult<
  EmbedPatientQuery,
  EmbedPatientQueryVariables
>;
export const GetAssignableSkillsDocument = gql`
  query getAssignableSkills {
    getAssignableSkills {
      moduleId
      skillId
      title
    }
  }
`;

/**
 * __useGetAssignableSkillsQuery__
 *
 * To run a query within a React component, call `useGetAssignableSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignableSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignableSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssignableSkillsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAssignableSkillsQuery,
    GetAssignableSkillsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetAssignableSkillsQuery, GetAssignableSkillsQueryVariables>(
    GetAssignableSkillsDocument,
    options
  );
}
export function useGetAssignableSkillsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAssignableSkillsQuery,
    GetAssignableSkillsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetAssignableSkillsQuery, GetAssignableSkillsQueryVariables>(
    GetAssignableSkillsDocument,
    options
  );
}
export type GetAssignableSkillsQueryHookResult = ReturnType<typeof useGetAssignableSkillsQuery>;
export type GetAssignableSkillsLazyQueryHookResult = ReturnType<
  typeof useGetAssignableSkillsLazyQuery
>;
export type GetAssignableSkillsQueryResult = ApolloReactCommon.QueryResult<
  GetAssignableSkillsQuery,
  GetAssignableSkillsQueryVariables
>;
export const GetSkillsAssignedToUserDocument = gql`
  query getSkillsAssignedToUser($userId: Float!, $page: Float!, $perPage: Float!) {
    getSkillsAssignedToUser(userId: $userId, page: $page, perPage: $perPage) {
      pagination {
        page
        totalPages
      }
      skillAssignments {
        id
        userId
        assignedById
        skillId
        moduleId
        userHasSeen
        assignerHasSeen
        completedAt
        startedAt
        createdAt
        skillTitle
        skillReflection {
          title
          questions {
            question
            answer
          }
        }
      }
    }
  }
`;

/**
 * __useGetSkillsAssignedToUserQuery__
 *
 * To run a query within a React component, call `useGetSkillsAssignedToUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsAssignedToUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsAssignedToUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetSkillsAssignedToUserQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetSkillsAssignedToUserQuery,
    GetSkillsAssignedToUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetSkillsAssignedToUserQuery,
    GetSkillsAssignedToUserQueryVariables
  >(GetSkillsAssignedToUserDocument, options);
}
export function useGetSkillsAssignedToUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSkillsAssignedToUserQuery,
    GetSkillsAssignedToUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetSkillsAssignedToUserQuery,
    GetSkillsAssignedToUserQueryVariables
  >(GetSkillsAssignedToUserDocument, options);
}
export type GetSkillsAssignedToUserQueryHookResult = ReturnType<
  typeof useGetSkillsAssignedToUserQuery
>;
export type GetSkillsAssignedToUserLazyQueryHookResult = ReturnType<
  typeof useGetSkillsAssignedToUserLazyQuery
>;
export type GetSkillsAssignedToUserQueryResult = ApolloReactCommon.QueryResult<
  GetSkillsAssignedToUserQuery,
  GetSkillsAssignedToUserQueryVariables
>;
export const AssignSkillToUserDocument = gql`
  mutation assignSkillToUser($skillId: String!, $moduleId: String!, $userId: Float!) {
    assignSkillToUser(skillId: $skillId, moduleId: $moduleId, userId: $userId) {
      isDuplicate
      wasAssigned
    }
  }
`;
export type AssignSkillToUserMutationFn = ApolloReactCommon.MutationFunction<
  AssignSkillToUserMutation,
  AssignSkillToUserMutationVariables
>;

/**
 * __useAssignSkillToUserMutation__
 *
 * To run a mutation, you first call `useAssignSkillToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignSkillToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignSkillToUserMutation, { data, loading, error }] = useAssignSkillToUserMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      moduleId: // value for 'moduleId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignSkillToUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AssignSkillToUserMutation,
    AssignSkillToUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AssignSkillToUserMutation,
    AssignSkillToUserMutationVariables
  >(AssignSkillToUserDocument, options);
}
export type AssignSkillToUserMutationHookResult = ReturnType<typeof useAssignSkillToUserMutation>;
export type AssignSkillToUserMutationResult =
  ApolloReactCommon.MutationResult<AssignSkillToUserMutation>;
export type AssignSkillToUserMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AssignSkillToUserMutation,
  AssignSkillToUserMutationVariables
>;
export const MarkSkillAssignmentSeenByAssignerDocument = gql`
  mutation markSkillAssignmentSeenByAssigner($skillAssignmentId: Float!) {
    markSkillAssignmentSeenByAssigner(skillAssignmentId: $skillAssignmentId)
  }
`;
export type MarkSkillAssignmentSeenByAssignerMutationFn = ApolloReactCommon.MutationFunction<
  MarkSkillAssignmentSeenByAssignerMutation,
  MarkSkillAssignmentSeenByAssignerMutationVariables
>;

/**
 * __useMarkSkillAssignmentSeenByAssignerMutation__
 *
 * To run a mutation, you first call `useMarkSkillAssignmentSeenByAssignerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSkillAssignmentSeenByAssignerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSkillAssignmentSeenByAssignerMutation, { data, loading, error }] = useMarkSkillAssignmentSeenByAssignerMutation({
 *   variables: {
 *      skillAssignmentId: // value for 'skillAssignmentId'
 *   },
 * });
 */
export function useMarkSkillAssignmentSeenByAssignerMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MarkSkillAssignmentSeenByAssignerMutation,
    MarkSkillAssignmentSeenByAssignerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    MarkSkillAssignmentSeenByAssignerMutation,
    MarkSkillAssignmentSeenByAssignerMutationVariables
  >(MarkSkillAssignmentSeenByAssignerDocument, options);
}
export type MarkSkillAssignmentSeenByAssignerMutationHookResult = ReturnType<
  typeof useMarkSkillAssignmentSeenByAssignerMutation
>;
export type MarkSkillAssignmentSeenByAssignerMutationResult =
  ApolloReactCommon.MutationResult<MarkSkillAssignmentSeenByAssignerMutation>;
export type MarkSkillAssignmentSeenByAssignerMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    MarkSkillAssignmentSeenByAssignerMutation,
    MarkSkillAssignmentSeenByAssignerMutationVariables
  >;
export const UnassignSkillFromUserDocument = gql`
  mutation unassignSkillFromUser($skillAssignmentId: Float!, $userId: Float!) {
    unassignSkillFromUser(skillAssignmentId: $skillAssignmentId, userId: $userId)
  }
`;
export type UnassignSkillFromUserMutationFn = ApolloReactCommon.MutationFunction<
  UnassignSkillFromUserMutation,
  UnassignSkillFromUserMutationVariables
>;

/**
 * __useUnassignSkillFromUserMutation__
 *
 * To run a mutation, you first call `useUnassignSkillFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignSkillFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignSkillFromUserMutation, { data, loading, error }] = useUnassignSkillFromUserMutation({
 *   variables: {
 *      skillAssignmentId: // value for 'skillAssignmentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnassignSkillFromUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnassignSkillFromUserMutation,
    UnassignSkillFromUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UnassignSkillFromUserMutation,
    UnassignSkillFromUserMutationVariables
  >(UnassignSkillFromUserDocument, options);
}
export type UnassignSkillFromUserMutationHookResult = ReturnType<
  typeof useUnassignSkillFromUserMutation
>;
export type UnassignSkillFromUserMutationResult =
  ApolloReactCommon.MutationResult<UnassignSkillFromUserMutation>;
export type UnassignSkillFromUserMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UnassignSkillFromUserMutation,
  UnassignSkillFromUserMutationVariables
>;
